export const SUPPORTED_LOCALES = ['de', 'en', 'fr', 'it'];

export const LANGUAGE_OPTIONS = [
  { code: 'de', label: 'Deutsch', shortLabel: 'DE' },
  { code: 'en', label: 'English', shortLabel: 'EN' },
  { code: 'fr', label: 'Français', shortLabel: 'FR' },
  { code: 'it', label: 'Italiano', shortLabel: 'IT' },
];

export const translations = {
  de: {
    localeName: 'Deutsch',
    document: {
      titleSuffix: 'YourApplicant',
      pageTitles: {
        home: 'Schüler:innen',
        schools: 'Schulen',
        companies: 'Unternehmen',
        pricing: 'Preise',
        about: 'Über Uns',
        coach: 'Coach Anna',
        motivationLetter: 'Motivationsschreiben',
        cv: 'Lebenslauf',
        careerCheck: 'Berufscheck',
        apprenticeships: 'Lehrstellen',
      },
    },
    common: {
      nav: {
        students: 'Schüler:innen',
        schools: 'Schulen',
        companies: 'Unternehmen',
        pricing: 'Preise',
        about: 'Über Uns',
      },
      actions: {
        login: 'Anmelden',
        start: 'Jetzt Starten',
        startLower: 'Jetzt starten',
        discover: 'Entdecken',
        create: 'Erstellen',
        beFound: 'Gefunden werden',
        apply: 'Bewerben',
        register: 'Registrieren',
        viewPricing: 'Preise ansehen',
        bookCall: 'Gespräch vereinbaren',
        bookFreeCall: 'Kostenlosen Termin vereinbaren',
        contact: 'Kontakt aufnehmen',
        meetCoach: 'Coach kennenlernen',
        exploreJobs: 'Lehrstellen entdecken',
        createLetter: 'Motivationsschreiben erstellen',
        createCv: 'Lebenslauf erstellen',
        backHome: 'Zur Startseite',
      },
      labels: {
        scroll: 'Scrollen',
        online: 'Online',
      },
      aria: {
        home: 'YourApplicant Startseite',
        mainNavigation: 'Hauptnavigation',
        toggleNavigation: 'Navigation ein- oder ausblenden',
        openNavigation: 'Navigation öffnen',
        closeNavigation: 'Navigation schliessen',
        selectLanguage: 'Sprache auswählen',
        languageMenu: 'Sprachauswahl',
        skipToContent: 'Zum Inhalt springen',
        scrollToContent: 'Zum nächsten Abschnitt scrollen',
        previousSlide: 'Vorherige Folie',
        nextSlide: 'Nächste Folie',
        pauseAnimation: 'Animation pausieren',
        playAnimation: 'Animation abspielen',
        studentStories: 'Erfolgsgeschichten von Lernenden',
        productPreview: 'Vorschau der YourApplicant App',
        teacherDashboard: 'YourApplicant Dashboard für Lehrpersonen',
        candidatePreview: 'Vorschau eines Kandidatenprofils',
        decreasePositions: 'Anzahl Lehrstellen verringern',
        increasePositions: 'Anzahl Lehrstellen erhöhen',
        openFaq: 'Antwort öffnen',
        closeFaq: 'Antwort schliessen',
        externalLink: 'Öffnet in einem neuen Tab',
        loading: 'Inhalt wird geladen',
      },
      footer: {
        description:
          'YourApplicant hilft Schüler:innen, Schulen und Betrieben, einfach die richtige Lehrstelle zu finden – fachlich und menschlich.',
        pagesTitle: 'Seiten',
        informationTitle: 'Information',
        contactTitle: 'Kontakt',
        pages: {
          students: 'Schüler:innen',
          schools: 'Schulen',
          companies: 'Unternehmen',
          pricing: 'Preise',
          about: 'Über Uns',
        },
        resources: {
          motivationLetter: 'Motivationsschreiben',
          cv: 'Lebenslauf',
          careerCheck: 'Berufscheck',
          apprenticeships: 'Lehrstellen',
        },
        address: 'Bahnhofstrasse 1, 8001 Zürich',
        copyright: '© 2026 YourApplicant. Alle Rechte vorbehalten.',
        createdBy: 'Created by',
      },
    },
    home: {
      hero: {
        eyebrow: 'Kostenlos für Schüler:innen',
        title: 'Einfachster Weg zur Lehrstelle',
        subtitle: 'Der einfachste Weg zur Lehrstelle die zu dir passt.',
        cta: 'Jetzt Starten',
        proof: 'Von Lernenden empfohlen',
      },
      stories: {
        ariaLabel: 'Erfolgsgeschichten von Lernenden',
        cardLabel: 'Mein Match',
      },
      ribbon: 'Dein Dossier. Alle Chancen.',
      dossier: {
        eyebrow: 'Dossier',
        title: 'Einmal ausfüllen.',
        titleAccent: 'Immer bewerben.',
        description:
          'Erstelle dein Dossier einmal und versende jede Bewerbung in unter 5 Minuten, mit einem Profil das wirklich überzeugt.',
        cta: 'Erstellen',
      },
      talentPool: {
        eyebrow: 'Talentpool',
        title: 'Nicht nur Bewerben.',
        titleAccent: 'Gefunden werden.',
        description:
          'Lehrbetriebe entdecken dein Profil und kommen direkt auf dich zu, weil du genau zu ihnen passt.',
        cta: 'Gefunden werden',
        notification: 'UBS AG will dich kennenlernen',
      },
      matches: {
        eyebrow: 'Lehrstellen Matches',
        title: 'Passende Lehrstellen.',
        titleAccent: 'Direkt zu dir.',
        description:
          'Du musst nicht nur suchen. YourApplicant findet die Lehrstellen die zu dir passen. Automatisch.',
        companyLine: 'Lehrstelle bei YourApplicant in Zürich als',
        role: 'Kaufmann/-frau (Tourismus) EFZ',
        year: '2026',
        strength: 'Starker Match',
        reasonTitle: 'Warum DU passt',
        reason:
          'Du arbeitest gerne mit Menschen und interessierst dich für Reisen und andere Kulturen. Dein Volleyball-Engagement und dein Einsatz am Schulfest zeigen, dass du teamfähig bist und Verantwortung übernimmst. Deine Klassenlehrerin beschreibt dich als offen und kommunikativ. Mit zwei kaufmännischen Schnupperlehren und einem Schnitt von 5.1, passt du genau zu dem was YourApplicant sucht.',
        apply: 'Bewerben',
      },
      journey: {
        eyebrow: 'Hallo!',
        quote:
          'Vom ersten "Was will ich eigentlich werden?" bis zum unterschriebenen Lehrvertrag. Wieso schwierig, wenn es einfach sein kann?',
        pills: [
          'Persönlichkeitsbild',
          'Berufsorientierung',
          'Coach Anna',
          'Bewerben',
          'Matches',
          'Talentpool',
        ],
      },
      coach: {
        eyebrow: 'Coach Anna',
        title: 'Persönlicher Coach.',
        titleAccent: 'Immer bei dir.',
        description:
          'Von der Berufswahl bis zur Zusage. Coach Anna kennt dich, versteht dich und hat auf jede Frage eine Antwort.',
        cta: 'Starten',
      },
      faq: {
        eyebrow: 'Häufige Fragen',
        title: 'Deine Fragen, beantwortet.',
        items: [
          {
            question: 'Was ist YourApplicant?',
            answer:
              'YourApplicant ist eine kostenlose Plattform für Schüler:innen in der Schweiz, die eine Lehrstelle suchen. Du erstellst dein Profil einmal, findest passende Lehrstellen und wirst von Lehrbetrieben gefunden. Coach Anna begleitet dich vom ersten Schritt bis zur Zusage.',
          },
          {
            question: 'Ist YourApplicant wirklich kostenlos?',
            answer:
              'Ja. Für Schüler:innen ist YourApplicant komplett kostenlos. Du kannst dein Dossier erstellen, dich bewerben und Coach Anna nutzen, ohne etwas zu bezahlen.',
          },
          {
            question: 'Ab wann soll ich mit der Lehrstellensuche starten?',
            answer:
              'Am besten etwa ein Jahr vor dem Lehrbeginn. Mit dem Bewerben startest du idealerweise Mitte bis Ende der Sommerferien, denn dann schreiben viele Betriebe ihre Lehrstellen aus. Egal wo du gerade stehst, Coach Anna holt dich dort ab und zeigt dir, was als Nächstes dran ist.',
          },
          {
            question: 'Wie finde ich eine Lehrstelle, die zu mir passt?',
            answer:
              'Du erstellst dein Profil mit deinen Stärken und Interessen, und YourApplicant schlägt dir Lehrstellen vor, die wirklich zu dir passen. So musst du nicht hunderte Inserate durchsuchen, sondern siehst gleich, was zu dir passt.',
          },
          {
            question: 'Was bringt mir YourApplicant gegenüber normalen Lehrstellenportalen?',
            answer:
              'Normale Portale zeigen dir alle Lehrstellen. YourApplicant zeigt dir die, die zu dir passen, hilft dir bei der Bewerbung und lässt dich von Lehrbetrieben finden. Du bewirbst dich nicht nur, du wirst auch gefunden.',
          },
          {
            question: 'Wer sieht mein Profil?',
            answer:
              'Dein Profil sehen nur Lehrbetriebe, die zu dir passen könnten, und nur wenn du das möchtest. Du behältst die Kontrolle darüber, wer dich sieht und wann du dich bewirbst.',
          },
        ],
      },
      closing: {
        eyebrow: 'Deine Zukunft',
        title: 'Bereit für deinen nächsten Schritt?',
        description:
          'Deine Zukunft beginnt nicht mit einer perfekten Bewerbung. Sondern mit dem ersten Schritt.',
        cta: 'Jetzt starten',
      },
    },
    schools: {
      hero: {
        eyebrow: 'Lehrplan 21 konform',
        title: 'Der individuelle Weg in die Berufswelt',
        subtitle:
          'YourApplicant begleitet jede Schülerin und jeden Schüler individuell auf dem Weg in die Berufswelt.',
        primaryCta: 'Jetzt Starten',
        secondaryCta: 'Gespräch vereinbaren',
      },
      overview: {
        eyebrow: 'Warum moderne Schulen uns nutzen.',
        title: 'Weniger Aufwand für Lehrpersonen. Mehr Wirkung für Schüler:innen.',
        features: [
          {
            title: 'Klassenübersicht',
            description:
              'Sieh auf einen Blick wer wie weit ist. Profilfortschritt, Bewerbungsaktivität und offene Aufgaben für jede Schülerin und jeden Schüler.',
          },
          {
            title: 'Persönlichkeitsprofile',
            description:
              'Verstehe deine Klasse besser. Die psychometrischen Profile helfen dir den Unterricht individuell zu gestalten und jede Schülerin und jeden Schüler dort abzuholen wo sie stehen.',
          },
          {
            title: 'Alle involviert',
            description:
              'Eltern, Lehrpersonen und Schüler:innen arbeiten gemeinsam in YourApplicant. Fremdeinschätzungen teilen, Fortschritte verfolgen, immer auf dem gleichen Stand.',
          },
        ],
      },
      journey: {
        eyebrow: 'Lehrplan 21',
        title: 'So begleiten wir deine Klasse',
        phases: [
          {
            phase: 'Phase 1',
            title: 'Selbstreflexion',
            tags: ['Persönlichkeitsbild'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Hey Luca, du spielst Fussball im Verein. Warst du schon mal Captain?',
              },
              {
                speaker: 'student',
                text: 'Ja, eine Saison lang. Aber war jetzt nichts besonderes.',
              },
              {
                speaker: 'anna',
                text: 'Doch. Als Captain motivierst du dein Team und triffst Entscheidungen unter Druck. Genau das gehört in dein Profil.',
              },
            ],
          },
          {
            phase: 'Phase 2 & 3',
            title: 'Motivation',
            tags: ['Berufswahl', 'Matching'],
            dialogue: [
              {
                speaker: 'student',
                text: 'Ich weiss nicht was ich für einen Lehrberuf machen soll.',
              },
              {
                speaker: 'anna',
                text: 'Du baust Webseiten und gamest gerne. Schon mal an einen technischen Beruf wie Informatiker gedacht?',
              },
              {
                speaker: 'student',
                text: 'Nicht wirklich, aber klingt interessant.',
              },
              {
                speaker: 'anna',
                text: 'Soll ich dir zeigen wie ein typischer Tag als Informatiker aussieht und wieso der Beruf zu dir passt?',
              },
            ],
          },
          {
            phase: 'Phase 4',
            title: 'Unterlagen',
            tags: ['Lebenslauf', 'Bewerbungsprozess', 'Bewerben', 'Matches', 'Talentpool'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Hey Luca, sieht super aus! Vergiss deine Führungserfahrung als Basketball-Captain nicht zu erwähnen.',
              },
            ],
          },
        ],
      },
      steps: {
        eyebrow: 'Einfacher als gedacht',
        title: 'In 3 Schritten zur modernen Begleitung.',
        items: [
          {
            title: 'Registrieren',
            description: 'Schule anmelden und Profil einrichten. 3 Minuten.',
          },
          {
            title: 'Einladen',
            description: 'Klassen erstellen. Schüler:innen treten über QR Code bei. 15 Minuten.',
          },
          {
            title: 'Begleiten',
            description: 'Schüler:innen werden automatisch begleitet. Kein weiterer Aufwand.',
          },
        ],
      },
      faq: {
        eyebrow: 'Häufige Fragen',
        title: 'Deine Fragen, beantwortet.',
        contactLead: 'Hast du Fragen? Vereinbare einen kostenlosen Termin',
        contactCta: 'Kostenlosen Termin vereinbaren',
        emailLead: 'oder, schreibe uns eine Mail an',
        items: [
          {
            question: 'Kann YourApplicant in den Lehrplan 21 integriert werden?',
            answer:
              'Ja, YourApplicant ist direkt auf den Lehrplan 21 abgestimmt und deckt alle wichtigen Tätigkeiten der Phasen 1 bis 4 ab. Darüber hinaus unterstützt YourApplicant die Schüler:innen aktiv beim Bewerben. Ein Bereich den ihr als Lehrpersonen nicht mehr verantworten müsst.',
          },
          {
            question: 'Wie handhabt YourApplicant den Datenschutz?',
            answer:
              'Profile sind geschützt und nicht öffentlich zugänglich. Schulen und Schüler:innen behalten die Kontrolle über ihre Angaben; die Daten werden nur für die Begleitung und Lehrstellensuche verwendet und nicht verkauft.',
          },
          {
            question: 'Wie aufwändig ist die Einrichtung?',
            answer:
              'Die Schule ist in wenigen Minuten eingerichtet. Danach erstellst du Klassen und die Schüler:innen treten per QR Code bei. Es braucht keine Installation und keine aufwendige Schulung.',
          },
          {
            question: 'Auf welchen Geräten kann YourApplicant verwendet werden?',
            answer:
              'YourApplicant läuft im Browser auf Laptop, Tablet und Smartphone. Schüler:innen und Lehrpersonen können deshalb mit den Geräten arbeiten, die an der Schule bereits vorhanden sind.',
          },
        ],
      },
    },
    companies: {
      hero: {
        eyebrow: 'Jetzt noch kostenlos',
        title: 'Finde den Menschen der wirklich passt.',
        subtitle:
          'YourApplicant findet Lernende die nicht nur fachlich passen sondern auch menschlich zu eurem Betrieb und eurer Kultur passen.',
        primaryCta: 'Jetzt Starten',
        secondaryCta: 'Gespräch vereinbaren',
        applications: '+20 Bewerbungen',
        fit: 'Leandro erfüllt 4/4 Anforderungen',
        requirements: [
          '3x Kaufmännische Schnuppertage',
          'Hohe Offenheit & Extraversion',
          'Notendurchschnitt von 5.1',
          'Sekundarschule Niveau A',
        ],
      },
      features: {
        eyebrow: 'Für Ausbildungsbetriebe',
        title: 'Mehr als nur eine Stellenbörse.',
        items: [
          {
            title: 'Talentpool durchsuchen.',
            description:
              'Suche nach Talenten mit deinen spezifischen Anforderungen. Kontakt mit einem Klick.',
          },
          {
            title: 'Deine Stelle findet die Richtigen.',
            description:
              'Definiere einmal wen du suchst. Passende Schüler:innen erhalten deine Stelle als persönlichen Vorschlag.',
          },
          {
            title: 'Mehr als ein Lebenslauf.',
            description:
              'Lerne den Menschen hinter der Bewerbung kennen. Persönlichkeit, Erfahrungen, Stärken und Fremdeinschätzung auf einen Blick.',
          },
          {
            title: 'Kommunikation die funktioniert.',
            description:
              'Alles läuft über YourApplicant. Kein E-Mail Chaos, alles auf einen Blick. Schüler:innen werden automatisch erinnert zu antworten.',
          },
        ],
      },
      recruiting: {
        eyebrow: 'Bewerbungen',
        title: 'Recruiting ohne Chaos.',
        cta: 'Starten',
        items: [
          {
            title: 'Vollständige Unterlagen.',
            description:
              'Schüler:innen bewerben sich vollständig und einzigartig. Keine fehlenden Dokumente mehr.',
          },
          {
            title: 'Individueller Prozess',
            description:
              'Eigene Status definieren und Bewerbungen nach eurem internen Ablauf verwalten.',
          },
          {
            title: '10 Sekunden Screenen',
            description:
              'Alle wichtigen Informationen auf einen Blick. Bevor ein Dokument geöffnet wird.',
          },
        ],
        statusTitle: 'Statusname',
        statusLabels: [
          { label: 'Abteilung', count: 7 },
          { label: 'Schnuppertage', count: 3 },
          { label: 'Gespräch', count: 3 },
          { label: 'Absage', count: 8 },
          { label: 'Zusage', count: 5 },
          { label: 'Ablehnung', count: 3 },
          { label: '2. Gespräch', count: 3 },
          { label: 'Screening', count: 12 },
        ],
      },
      audiences: {
        eyebrow: 'Für jeden Betrieb',
        title: 'Für jeden der ausbildet.',
        cta: 'Jetzt loslegen',
        items: [
          {
            title: 'KMU',
            description:
              'Wenig Zeit, kleine HR-Ressourcen. Schnell zum passendsten Kandidaten kommen ohne grossen Aufwand.',
          },
          {
            title: 'Grossbetriebe',
            description:
              'Viele Bewerbungen, komplexe Prozesse. Strukturiertes Bewerbungsmanagement das sich in bestehende Abläufe integriert.',
          },
          {
            title: 'Betriebe mit Nachwuchsproblem',
            description:
              'Berufsfelder die Mühe haben Jugendliche zu begeistern. YourApplicant schlägt passenden Schüler:innen deine Stelle aktiv vor.',
          },
          {
            title: 'Betriebe die frühzeitig die Besten sichern',
            description:
              'Talente frühzeitig erkennen bevor sie vergeben sind. Mit dem Talentpool aktiv die Richtigen ansprechen.',
          },
        ],
      },
      steps: {
        eyebrow: 'Einfacher als gedacht',
        title: 'In 3 Schritten zum richtigen Lernenden.',
        items: [
          {
            title: 'Registrieren',
            description: 'Betrieb anmelden und Profil einrichten. 3 Minuten.',
          },
          {
            title: 'Inserieren',
            description: 'Stelle erfassen und Anforderungen definieren. 10 Minuten.',
          },
          {
            title: 'Bewerbungen erhalten',
            description:
              'Passende Schüler:innen bewerben sich direkt bei dir oder du suchst aktiv im Talentpool.',
          },
        ],
      },
      faq: {
        eyebrow: 'Häufige Fragen',
        title: 'Deine Fragen, beantwortet.',
        items: [
          {
            question: 'Was ist YourApplicant für Betriebe?',
            answer:
              'YourApplicant hilft Ausbildungsbetrieben, Lernende zu finden, die nicht nur fachlich, sondern auch menschlich passen. Ihr erhaltet vollständige Bewerbungen, könnt den Talentpool durchsuchen und werdet von passenden Schüler:innen gefunden. Alles an einem Ort, ohne E-Mail-Chaos.',
          },
          {
            question: 'Was kostet YourApplicant für Betriebe?',
            answer:
              'Der Einstieg ist kostenlos. Ihr könnt eine Lehrstelle ausschreiben und vollständige Bewerbungen erhalten, ohne etwas zu bezahlen. Wer aktiv im Talentpool suchen oder Wunschkandidat:innen direkt ansprechen will, wählt einen der bezahlten Tarife.',
          },
          {
            question: 'Wie aufwändig ist die Einrichtung?',
            answer:
              'Wenig. In rund drei Minuten meldet ihr euren Betrieb an und richtet euer Profil ein. Danach erfasst ihr eure Lehrstelle in etwa zehn Minuten und erhaltet passende Bewerbungen. Kein langes Setup, keine Schulung nötig.',
          },
          {
            question: 'Wie hilft YourApplicant gegen fehlende Bewerbungen?',
            answer:
              'Statt zu warten, bis sich jemand meldet, findet ihr selbst passende Schüler:innen im Talentpool und sprecht sie direkt an. Und eure Lehrstelle wird passenden Jugendlichen automatisch vorgeschlagen, auch wenn sie euch noch nicht kennen.',
          },
          {
            question: 'Sind die Bewerbungen vollständig?',
            answer:
              'Ja. Schüler:innen bewerben sich mit einem vollständigen Dossier, das ihre Persönlichkeit, Stärken und Erfahrungen zeigt. Ihr seht in wenigen Sekunden, ob jemand passt, bevor ihr überhaupt ein Dokument öffnet. Keine fehlenden Unterlagen mehr.',
          },
          {
            question: 'Für welche Betriebe eignet sich YourApplicant?',
            answer:
              'Für jeden Betrieb, der ausbildet. Vom KMU mit wenig Zeit und kleiner HR bis zum Grossbetrieb mit vielen Bewerbungen. Besonders wertvoll ist es für Betriebe, die schwer Nachwuchs finden oder sich die besten Talente früh sichern wollen.',
          },
        ],
      },
    },
    pricing: {
      hero: {
        eyebrow: 'Preis Übersicht',
        tabs: {
          companies: 'Unternehmen',
          schools: 'Schulen',
        },
        title: 'Unglaublich Einfach. Unglaublich Gut.',
      },
      counterLabel: 'Anzahl Lehrstellen',
      currency: 'CHF',
      period: '/ Jahr',
      includedLabel: 'Was ist inkludiert',
      plans: [
        {
          name: 'Starter',
          price: '0',
          description: 'Für KMU Betriebe. Einfach starten, sofort Bewerbungen erhalten.',
          features: [
            { label: 'Attraktive Stellenausschreibungen', available: true },
            { label: 'Hilfe beim Erstellen der Ausschreibung', available: true },
            {
              label: 'Stelle wird Wunschkandidat:innen vorgeschlagen',
              available: false,
            },
            { label: 'Bewerbungen screenen in 10 Sekunden', available: true },
            { label: 'Bewerbungen sind immer vollständig', available: true },
            { label: 'Persönliches Dossier zu allen Bewerbenden', available: true },
            { label: 'Gesamte Kommunikation an einem Ort', available: true },
            { label: 'Eigenen Bewerbungsprozess definieren', available: false },
            { label: 'Team einladen', available: false },
            { label: 'Talentpool Suche', available: false },
            { label: 'Kandidat:innen direkt ansprechen', available: false },
          ],
          cta: 'Jetzt starten',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Essential',
          price: '240',
          description: 'Für Betriebe die im Team rekrutieren und eigene Abläufe wollen.',
          features: [
            { label: 'Attraktive Stellenausschreibungen', available: true },
            { label: 'Hilfe beim Erstellen der Ausschreibung', available: true },
            {
              label: 'Stelle wird Wunschkandidat:innen vorgeschlagen',
              available: true,
            },
            { label: 'Bewerbungen screenen in 10 Sekunden', available: true },
            { label: 'Bewerbungen sind immer vollständig', available: true },
            { label: 'Persönliches Dossier zu allen Bewerbenden', available: true },
            { label: 'Gesamte Kommunikation an einem Ort', available: true },
            { label: 'Eigenen Bewerbungsprozess definieren', available: true },
            { label: 'Team einladen', available: true },
            { label: 'Talentpool Suche', available: false },
            { label: 'Kandidat:innen direkt ansprechen', available: false },
          ],
          cta: 'Jetzt starten',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Pro',
          price: '690',
          description:
            'Für Betriebe die aktiv suchen. Ideal um die Besten zu sichern, bevor sie weg sind.',
          features: [
            { label: 'Alles aus Essential', available: true },
            { label: 'Unlimitierte Talentpool Suche', available: true },
            {
              label: 'Wunschkandidat:innen direkt ansprechen bevor sie weg sind.',
              available: true,
            },
          ],
          cta: 'Jetzt starten',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Enterprise',
          price: 'Auf Anfrage',
          description: 'Für Grossbetriebe ab 10+ Lehrstellen.',
          features: [
            { label: 'Alles aus Pro', available: true },
            { label: 'Persönlicher Ansprechpartner', available: true },
            { label: 'Individueller Onboardingprozess', available: true },
            { label: 'Integration in bestehende Systeme', available: true },
          ],
          cta: 'Kontakt aufnehmen',
          ctaState: { disabled: true, gated: true, minimumPositions: 10 },
          note: 'Ab 10 Lehrstellen verfügbar.',
        },
      ],
      schoolsPanel: {
        eyebrow: 'Preis Übersicht',
        title: 'Für Schulen Gemacht.',
        titleAccent: 'Einfach Begleiten.',
        studentCountLabel: 'Anzahl Schüler:innen',
        trialBadge: '3 Monate kostenlos testen',
        price: '20',
        currency: 'CHF',
        period: '/ Jahr',
        perStudentLabel: 'pro Schüler:in und Jahr',
        description:
          'Für Schulen. Einfach starten und Schüler:innen individuell begleiten.',
        cta: 'Gespräch vereinbaren',
        note:
          'Wir klären zusammen alle offenen Fragen und besprechen nächste Schritte.',
        features: [
          { label: 'Attraktive Stellenausschreibungen', available: true },
          { label: 'Hilfe beim Erstellen der Ausschreibung', available: true },
          { label: 'Bewerbungen screenen in 10 Sekunden', available: true },
          { label: 'Bewerbungen sind immer vollständig', available: true },
          { label: 'Persönliches Dossier zu allen Bewerbenden', available: true },
          { label: 'Gesamte Kommunikation an einem Ort', available: true },
          { label: 'Eigenen Bewerbungsprozess definieren', available: true },
          { label: 'Team einladen', available: true },
          { label: 'Talentpool Suche', available: false },
          { label: 'Kandidat:innen direkt ansprechen', available: false },
        ],
      },
    },
    about: {
      hero: {
        title: 'Eine passende Lehrstelle verändert ein Leben.',
        subtitle:
          'Wir sind überzeugt dass ein echter Match, fachlich und menschlich, Jugendliche motivierter macht, ihr Potenzial besser entfalten lässt und sie mehr lernen. Ein besserer Start ins Leben und die Nachwuchstalente die die Schweizer Wirtschaft braucht.',
      },
      story: {
        title: 'Wie YourApplicant entstanden ist',
        description:
          'Devin Baucamp erzählt von seiner eigenen Geschichte, wie YourApplicant entstanden ist und seine Motivation hinter der Bewegung',
        videoAria: 'Geschichte von YourApplicant abspielen',
      },
      team: {
        eyebrow: 'Die Menschen dahinter',
        title: 'Unser Team',
        members: [
          { name: 'Devin Baucamp', role: 'CEO & Gründer' },
          { name: 'Lubo Dilov', role: 'Lead Entwickler' },
          { name: 'Aleksander Dimitrov', role: 'Frontend Entwickler' },
          { name: 'Aleyna Arslan', role: 'Content & Marketing' },
          { name: 'Samira Bannwart', role: 'Beirat & Sales' },
          { name: 'Leon Sarkis', role: 'Sales & Partnerschaften' },
        ],
      },
    },
    resources: {
      coach: {
        slug: '/coach',
        hero: {
          eyebrow: 'Kostenlos für Schüler:innen',
          title: 'Dein persönlicher Coach.',
          titleAccent: 'Immer bei dir.',
          subtitle:
            'Von der Berufswahl bis zur Zusage. Coach Anna kennt dich, versteht dich und begleitet dich bei jedem Schritt.',
          cta: 'Jetzt starten',
        },
        intro:
          'Du musst deinen Weg zur Lehrstelle nicht allein herausfinden. Coach Anna lernt dich über dein Profil kennen, beantwortet deine Fragen und zeigt dir genau den nächsten sinnvollen Schritt.',
        section: {
          title: 'Coach Anna begleitet dich',
          items: [
            {
              title: 'Sie lernt dich kennen.',
              description:
                'Über dein Profil versteht Coach Anna deine Interessen, Stärken und Erfahrungen.',
            },
            {
              title: 'Sie denkt mit dir.',
              description:
                'Frag sie alles zur Berufswahl, zum Dossier oder zur Bewerbung. Du bekommst eine Antwort, die zu dir passt.',
            },
            {
              title: 'Sie bleibt an deiner Seite.',
              description:
                'Von der ersten Idee bis zur Zusage erinnert sie dich an das, was als Nächstes wichtig ist.',
            },
          ],
        },
        cta: {
          title: 'Coach Anna kennenlernen',
          subtitle: 'Kostenlos, persönlich und jederzeit für dich da.',
          label: 'Jetzt starten',
        },
        faq: {
          title: 'Häufige Fragen zu Coach Anna.',
          items: [
            {
              question: 'Was ist Coach Anna?',
              answer:
                'Coach Anna ist deine persönliche Begleitung bei YourApplicant. Sie kennt dein Profil, beantwortet deine Fragen und unterstützt dich von der Berufswahl bis zur Zusage, jederzeit und ganz auf dich abgestimmt.',
            },
            {
              question: 'Was kann ich Coach Anna fragen?',
              answer:
                'Du kannst alles fragen, was mit deiner Berufswahl und Lehrstellensuche zu tun hat: passende Berufe, deine Stärken, Lebenslauf, Motivationsschreiben, Bewerbungen oder ein bevorstehendes Gespräch.',
            },
            {
              question: 'Ist Coach Anna kostenlos?',
              answer:
                'Ja. Coach Anna und alle Funktionen von YourApplicant sind für Schüler:innen kostenlos.',
            },
            {
              question: 'Ersetzt Coach Anna eine Berufsberatung?',
              answer:
                'Coach Anna ergänzt die Unterstützung durch Eltern, Schule und Berufsberatung. Sie ist jederzeit erreichbar und hilft dir, deine nächsten Schritte vorzubereiten und umzusetzen.',
            },
          ],
        },
      },
      motivationLetter: {
        slug: '/motivationsschreiben-lehrstelle',
        hero: {
          eyebrow: 'Kostenlos für Schüler:innen',
          title: 'Dein Motivationsschreiben.',
          titleAccent: 'Das überzeugt.',
          subtitle:
            'Schreib in wenigen Minuten ein Motivationsschreiben für deine Lehrstelle, das wirklich zu dir passt.',
          cta: 'Jetzt Starten',
        },
        intro:
          'Ein gutes Motivationsschreiben entscheidet oft, ob du zum Gespräch eingeladen wirst. Hier erfährst du, worauf Lehrbetriebe achten und wie du ein Motivationsschreiben für deine Lehrstelle erstellst, das überzeugt.',
        section: {
          title: 'So wird dein Motivationsschreiben gut',
          items: [
            {
              title: 'Zeig, warum genau dieser Betrieb.',
              description:
                'Schreib nicht allgemein, sondern was dich an genau dieser Lehrstelle reizt.',
            },
            {
              title: 'Bring ein Beispiel von dir.',
              description:
                'Eine Schnupperlehre, ein Hobby, ein Projekt das zu dir und zum Beruf passt.',
            },
            {
              title: 'Weniger ist mehr.',
              description:
                'Eine halbe Seite reicht. Lieber ein, zwei echte Punkte als viele leere Sätze.',
            },
          ],
        },
        cta: {
          title: 'Motivationsschreiben erstellen',
          subtitle: 'Mit Coach Anna. Kostenlos, in wenigen Minuten.',
          label: 'Motivationsschreiben erstellen',
        },
        faq: {
          title: 'Häufige Fragen zum Motivationsschreiben.',
          items: [
            {
              question: 'Wie lange muss ein Motivationsschreiben sein?',
              answer:
                'Eine halbe bis höchstens eine ganze A4-Seite. Lehrbetriebe lesen viele Bewerbungen, darum zählt jeder Satz. Drei bis vier kurze Abschnitte reichen völlig.',
            },
            {
              question: 'Wie fange ich ein Motivationsschreiben an?',
              answer:
                'Sag gleich im ersten Satz, für welche Lehrstelle du dich bewirbst und warum sie dich interessiert. Lass lange Einleitungen weg und komm direkt zum Punkt.',
            },
            {
              question: 'Was gehört in ein Motivationsschreiben?',
              answer:
                'Drei Dinge: warum genau dieser Betrieb, was du schon mitbringst (eine Schnupperlehre, ein Hobby, deine Stärken) und warum du zum Beruf passt. Am Schluss ein kurzer Satz, dass du dich auf ein Gespräch freust.',
            },
            {
              question: 'Was ist der Unterschied zwischen Motivationsschreiben und Bewerbungsschreiben',
              answer:
                'Meistens ist dasselbe gemeint. Beide erklären, warum du dich für die Lehrstelle bewirbst und warum du passt. Manche Betriebe sagen Motivationsschreiben, andere Bewerbungsschreiben.',
            },
          ],
        },
      },
      cv: {
        slug: '/lebenslauf-lehrstelle',
        hero: {
          eyebrow: 'Kostenlos für Schüler:innen',
          title: 'Dein Lebenslauf.',
          titleAccent: 'In wenigen Minuten.',
          subtitle:
            'Erstell einen sauberen Lebenslauf für deine Lehrstelle, der alles Wichtige zeigt.',
          cta: 'Jetzt Starten',
        },
        intro:
          'Der Lebenslauf ist das Erste, was ein Lehrbetrieb von dir sieht. Hier erfährst du, was in einen Lebenslauf für die Lehrstelle gehört und wie du in wenigen Minuten einen erstellst, der sauber und vollständig ist.',
        section: {
          title: 'So wird dein Lebenslauf gut',
          items: [
            {
              title: 'Das Neueste zuerst.',
              description:
                'Beginn mit deiner jetzigen Schule und geh dann rückwärts. Das Aktuellste steht oben.',
            },
            {
              title: 'Zeig, was dich ausmacht.',
              description:
                'Such dir drei, vier echte Stärken aus, statt eine lange Liste. Lieber wenige, die wirklich zu dir passen.',
            },
            {
              title: 'Halt es übersichtlich.',
              description:
                'Eine Seite, klare Abschnitte, ein gutes Foto. Lehrbetriebe entscheiden in Sekunden.',
            },
          ],
        },
        cta: {
          title: 'Lebenslauf erstellen',
          subtitle: 'Mit Coach Anna. Kostenlos, in wenigen Minuten.',
          label: 'Lebenslauf erstellen',
        },
        faq: {
          title: 'Häufige Fragen zum Lebenslauf.',
          items: [
            {
              question: 'Was gehört in einen Lebenslauf für die Lehrstelle?',
              answer:
                'Deine persönlichen Angaben, deine Schulbildung, allfällige Schnupperlehren, deine Hobbys, Sprachen und Stärken. Ein aktuelles, freundliches Foto gehört nach oben.',
            },
            {
              question: 'Wie lang soll ein Lebenslauf sein?',
              answer:
                'Eine A4-Seite reicht. Als Schüler:in hast du noch keine lange Berufserfahrung, darum bleibt der Lebenslauf kurz und übersichtlich.',
            },
            {
              question: 'Braucht ein Lebenslauf ein Foto?',
              answer:
                'In der Schweiz ja. Ein gutes, neutrales Foto gehört zu einer vollständigen Bewerbung. Mach es freundlich und ordentlich, kein Selfie und kein Ferienbild.',
            },
            {
              question: 'Was ist der Unterschied zwischen Lebenslauf und CV?',
              answer:
                'Gar keiner. CV ist die englische Abkürzung für Curriculum Vitae und meint genau dasselbe wie Lebenslauf.',
            },
          ],
        },
      },
      careerCheck: {
        slug: '/berufscheck',
        hero: {
          eyebrow: 'Kostenlos für Schüler:innen',
          title: 'Welcher Beruf',
          titleAccent: 'passt zu dir?',
          subtitle:
            'Finde es nicht allein heraus. Coach Anna begleitet dich, bis du den Beruf gefunden hast, der zu dir passt.',
          cta: 'Jetzt starten',
        },
        intro:
          'Keine Ahnung, was du werden willst? Das ist völlig normal, und du musst es auch nicht allein herausfinden. Coach Anna lernt dich über dein Profil kennen, geht mit dir durch, was dir liegt, und begleitet dich Schritt für Schritt bis zur passenden Lehrstelle.',
        section: {
          title: 'Coach Anna begleitet dich',
          items: [
            {
              title: 'Beantworte ein paar Fragen.',
              description:
                'Über ein paar Fragen und dein Profil versteht Coach Anna, was dich ausmacht und was dir liegt.',
            },
            {
              title: 'Sie denkt mit dir.',
              description:
                'Du kannst sie alles fragen. Coach Anna hilft dir, Klarheit zu finden, in deinem Tempo.',
            },
            {
              title: 'Sie bringt dich zur passenden Lehrstelle.',
              description:
                'Aus allem, was sie über dich weiss, zeigt sie dir Berufe und Lehrstellen, die wirklich zu dir passen.',
            },
          ],
        },
        cta: {
          title: 'Jetzt starten',
          subtitle: 'Mit Coach Anna. Kostenlos, in wenigen Minuten.',
          label: 'Jetzt starten',
        },
        faq: {
          title: 'Häufige Fragen zur Berufswahl.',
          items: [
            {
              question: 'Wie finde ich heraus, welcher Beruf zu mir passt?',
              answer:
                'Du musst das nicht allein herausfinden. Coach Anna begleitet dich Schritt für Schritt, lernt dich über dein ganzes Profil kennen und hilft dir, den Beruf zu finden, der wirklich zu dir passt. Der Test ist dabei nur der Anfang.',
            },
            {
              question: 'Was ist Coach Anna?',
              answer:
                'Coach Anna ist deine persönliche Begleitung bei YourApplicant. Sie kennt dein Profil, beantwortet deine Fragen und unterstützt dich von der Berufswahl bis zur Zusage, jederzeit und ganz auf dich abgestimmt.',
            },
            {
              question: 'Was, wenn ich noch gar keine Ahnung habe, was ich will?',
              answer:
                'Genau dafür ist YourApplicant da. Du musst nichts wissen, wenn du startest. Coach Anna geht mit dir durch, was dir liegt und was dich interessiert, und hilft dir, Schritt für Schritt Klarheit zu finden.',
            },
          ],
        },
      },
      apprenticeships: {
        slug: '/lehrstellen',
        hero: {
          eyebrow: 'Kostenlos für Schüler:innen',
          title: 'Lehrstellen finden,',
          titleAccent: 'die zu dir passen.',
          subtitle:
            'Such nicht hunderte Inserate durch. YourApplicant zeigt dir offene Lehrstellen, die wirklich zu dir passen.',
          cta: 'Lehrstellen entdecken',
        },
        intro:
          'Es gibt tausende offene Lehrstellen. Aber welche passt zu dir? Statt alle Inserate durchzuklicken, schlägt dir YourApplicant Lehrstellen vor, die zu deiner Persönlichkeit und deinen Stärken passen, in deiner Nähe.',
        section: {
          title: 'So findest du deine Lehrstelle',
          items: [
            {
              title: 'Sag uns, was dich ausmacht.',
              description:
                'Über dein Profil lernt YourApplicant deine Stärken, Interessen und deine Region kennen.',
            },
            {
              title: 'Sieh passende Lehrstellen.',
              description:
                'Du bekommst Lehrstellen vorgeschlagen, die wirklich zu dir passen, statt einer endlosen Liste.',
            },
            {
              title: 'Werd gefunden.',
              description:
                'Lehrbetriebe entdecken dein Profil und kommen direkt auf dich zu.',
            },
          ],
        },
        cta: {
          title: 'Lehrstellen entdecken',
          subtitle: 'Mit Coach Anna. Kostenlos, in wenigen Minuten.',
          label: 'Lehrstellen entdecken',
        },
        faq: {
          title: 'Häufige Fragen zur Lehrstellensuche',
          items: [
            {
              question: 'Wo finde ich offene Lehrstellen in der Schweiz?',
              answer:
                'Offene Lehrstellen findest du auf verschiedenen Portalen. YourApplicant geht einen Schritt weiter und schlägt dir gezielt die Lehrstellen vor, die zu deiner Persönlichkeit, deinen Stärken und deiner Nähe passen.',
            },
            {
              question: 'Ab wann soll ich eine Lehrstelle suchen?',
              answer:
                'Meist etwa ein Jahr vor dem Lehrbeginn, oft in der 3. Sek. Manche Betriebe vergeben früh, darum lohnt es sich, rechtzeitig dran zu sein.',
            },
            {
              question: 'Wie viele Lehrstellen soll ich mir anschauen?',
              answer:
                'Lieber wenige, die wirklich passen, als hundert auf Verdacht. Wenn die Lehrstelle zu dir passt, sind auch deine Chancen im Bewerbungsprozess höher.',
            },
            {
              question: 'Was, wenn ich noch nicht weiss, welchen Beruf ich will?',
              answer:
                'Kein Problem. Starte mit dem Berufscheck. YourApplicant findet zuerst heraus, was zu dir passt, und zeigt dir dann passende Lehrstellen.',
            },
          ],
        },
      },
    },
  },
  fr: {
    localeName: 'Français',
    document: {
      titleSuffix: 'YourApplicant',
      pageTitles: {
        home: 'Élèves',
        schools: 'Écoles',
        companies: 'Entreprises',
        pricing: 'Tarifs',
        about: 'À propos',
        coach: 'Coach Anna',
        motivationLetter: 'Lettre de motivation',
        cv: 'CV',
        careerCheck: 'Choix professionnel',
        apprenticeships: 'Places d’apprentissage',
      },
    },
    common: {
      nav: {
        students: 'Élèves',
        schools: 'Écoles',
        companies: 'Entreprises',
        pricing: 'Tarifs',
        about: 'À propos',
      },
      actions: {
        login: 'Se connecter',
        start: 'Commencer maintenant',
        startLower: 'Commencer maintenant',
        discover: 'Découvrir',
        create: 'Créer',
        beFound: 'Se faire repérer',
        apply: 'Postuler',
        register: 'S’inscrire',
        viewPricing: 'Voir les tarifs',
        bookCall: 'Planifier un entretien',
        bookFreeCall: 'Planifier un entretien gratuit',
        contact: 'Nous contacter',
        meetCoach: 'Découvrir Coach Anna',
        exploreJobs: 'Découvrir les places d’apprentissage',
        createLetter: 'Créer une lettre de motivation',
        createCv: 'Créer un CV',
        backHome: 'Retour à l’accueil',
      },
      labels: {
        scroll: 'Défiler',
        online: 'En ligne',
      },
      aria: {
        home: 'Accueil YourApplicant',
        mainNavigation: 'Navigation principale',
        toggleNavigation: 'Afficher ou masquer la navigation',
        openNavigation: 'Ouvrir la navigation',
        closeNavigation: 'Fermer la navigation',
        selectLanguage: 'Choisir la langue',
        languageMenu: 'Sélection de la langue',
        skipToContent: 'Aller au contenu',
        scrollToContent: 'Faire défiler jusqu’à la section suivante',
        previousSlide: 'Diapositive précédente',
        nextSlide: 'Diapositive suivante',
        pauseAnimation: 'Mettre l’animation en pause',
        playAnimation: 'Lancer l’animation',
        studentStories: 'Témoignages de réussite d’apprenti·es',
        productPreview: 'Aperçu de l’app YourApplicant',
        teacherDashboard: 'Tableau de bord YourApplicant pour le corps enseignant',
        candidatePreview: 'Aperçu d’un profil de candidature',
        decreasePositions: 'Réduire le nombre de places d’apprentissage',
        increasePositions: 'Augmenter le nombre de places d’apprentissage',
        openFaq: 'Ouvrir la réponse',
        closeFaq: 'Fermer la réponse',
        externalLink: 'S’ouvre dans un nouvel onglet',
        loading: 'Chargement du contenu',
      },
      footer: {
        description:
          'YourApplicant aide les élèves, les écoles et les entreprises formatrices à trouver facilement la bonne place d’apprentissage, sur le plan professionnel et humain.',
        pagesTitle: 'Pages',
        informationTitle: 'Informations',
        contactTitle: 'Contact',
        pages: {
          students: 'Élèves',
          schools: 'Écoles',
          companies: 'Entreprises',
          pricing: 'Tarifs',
          about: 'À propos',
        },
        resources: {
          motivationLetter: 'Lettre de motivation',
          cv: 'CV',
          careerCheck: 'Choix professionnel',
          apprenticeships: 'Places d’apprentissage',
        },
        address: 'Bahnhofstrasse 1, 8001 Zürich',
        copyright: '© 2026 YourApplicant. Tous droits réservés.',
        createdBy: 'Créé par',
      },
    },
    home: {
      hero: {
        eyebrow: 'Gratuit pour les élèves',
        title: 'Le chemin le plus simple vers l’apprentissage',
        subtitle: 'Le chemin le plus simple vers la place d’apprentissage qui te correspond.',
        cta: 'Commencer maintenant',
        proof: 'Recommandé par des apprenti·es',
      },
      stories: {
        ariaLabel: 'Témoignages de réussite d’apprenti·es',
        cardLabel: 'Mon match',
      },
      ribbon: 'Ton dossier. Toutes tes chances.',
      dossier: {
        eyebrow: 'Dossier',
        title: 'Remplis-le une fois.',
        titleAccent: 'Postule à tout moment.',
        description:
          'Crée ton dossier une seule fois et envoie chaque candidature en moins de 5 minutes, avec un profil qui convainc vraiment.',
        cta: 'Créer',
      },
      talentPool: {
        eyebrow: 'Vivier de talents',
        title: 'Ne te contente pas de postuler.',
        titleAccent: 'Fais-toi repérer.',
        description:
          'Les entreprises formatrices découvrent ton profil et te contactent directement, parce que tu leur corresponds vraiment.',
        cta: 'Se faire repérer',
        notification: 'UBS AG souhaite faire ta connaissance',
      },
      matches: {
        eyebrow: 'Matches d’apprentissage',
        title: 'Des places qui te correspondent.',
        titleAccent: 'Directement pour toi.',
        description:
          'Tu ne dois pas te contenter de chercher. YourApplicant trouve automatiquement les places d’apprentissage qui te correspondent.',
        companyLine: 'Place d’apprentissage chez YourApplicant à Zürich :',
        role: 'Employé·e de commerce (Tourisme) CFC',
        year: '2026',
        strength: 'Excellent match',
        reasonTitle: 'Pourquoi TU corresponds au profil',
        reason:
          'Tu aimes travailler avec les autres et tu t’intéresses aux voyages et aux autres cultures. Ton engagement dans le volleyball et ta participation à la fête de l’école montrent ton esprit d’équipe et ton sens des responsabilités. Ton enseignante de classe te décrit comme une personne ouverte et communicative. Avec deux stages d’observation dans le commerce et une moyenne de 5.1, tu corresponds exactement à ce que recherche YourApplicant.',
        apply: 'Postuler',
      },
      journey: {
        eyebrow: 'Bonjour !',
        quote:
          'De la première question « Quel métier ai-je vraiment envie de faire ? » jusqu’au contrat d’apprentissage signé. Pourquoi faire compliqué quand tout peut être simple ?',
        pills: [
          'Profil de personnalité',
          'Orientation professionnelle',
          'Coach Anna',
          'Postuler',
          'Matches',
          'Vivier de talents',
        ],
      },
      coach: {
        eyebrow: 'Coach Anna',
        title: 'Ta coach personnelle.',
        titleAccent: 'Toujours à tes côtés.',
        description:
          'Du choix du métier jusqu’à la réponse positive. Coach Anna te connaît, te comprend et répond à toutes tes questions.',
        cta: 'Commencer',
      },
      faq: {
        eyebrow: 'Questions fréquentes',
        title: 'Tes questions, nos réponses.',
        items: [
          {
            question: 'Qu’est-ce que YourApplicant ?',
            answer:
              'YourApplicant est une plateforme gratuite destinée aux élèves en Suisse qui recherchent une place d’apprentissage. Tu crées ton profil une seule fois, tu trouves des places adaptées et les entreprises formatrices peuvent te repérer. Coach Anna t’accompagne du premier pas jusqu’à la réponse positive.',
          },
          {
            question: 'YourApplicant est-il vraiment gratuit ?',
            answer:
              'Oui. YourApplicant est entièrement gratuit pour les élèves. Tu peux créer ton dossier, postuler et utiliser Coach Anna sans rien payer.',
          },
          {
            question: 'Quand dois-je commencer à chercher une place d’apprentissage ?',
            answer:
              'Idéalement, environ un an avant le début de l’apprentissage. Le mieux est de commencer à postuler entre le milieu et la fin des vacances d’été, lorsque de nombreuses entreprises publient leurs places. Où que tu en sois, Coach Anna te rejoint à cette étape et te montre la suite.',
          },
          {
            question: 'Comment trouver une place d’apprentissage qui me correspond ?',
            answer:
              'Tu crées ton profil avec tes points forts et tes intérêts, puis YourApplicant te propose des places d’apprentissage qui te correspondent vraiment. Plus besoin de parcourir des centaines d’annonces : tu vois immédiatement ce qui te convient.',
          },
          {
            question: 'Que m’apporte YourApplicant par rapport aux portails classiques ?',
            answer:
              'Les portails classiques te montrent toutes les places. YourApplicant te montre celles qui te correspondent, t’aide à postuler et permet aux entreprises formatrices de te repérer. Tu ne fais pas que postuler : on te trouve aussi.',
          },
          {
            question: 'Qui peut voir mon profil ?',
            answer:
              'Seules les entreprises formatrices susceptibles de te correspondre voient ton profil, et uniquement si tu le souhaites. Tu gardes le contrôle sur les personnes qui te voient et sur le moment où tu postules.',
          },
        ],
      },
      closing: {
        eyebrow: 'Ton avenir',
        title: 'Prêt·e pour la prochaine étape ?',
        description:
          'Ton avenir ne commence pas par une candidature parfaite, mais par un premier pas.',
        cta: 'Commencer maintenant',
      },
    },
    schools: {
      hero: {
        eyebrow: 'Conforme au Plan d’études 21',
        title: 'Un parcours individuel vers le monde professionnel',
        subtitle:
          'YourApplicant accompagne chaque élève individuellement sur le chemin du monde professionnel.',
        primaryCta: 'Commencer maintenant',
        secondaryCta: 'Planifier un entretien',
      },
      overview: {
        eyebrow: 'Pourquoi les écoles modernes nous choisissent.',
        title: 'Moins de travail pour le corps enseignant. Plus d’impact pour les élèves.',
        features: [
          {
            title: 'Vue d’ensemble de la classe',
            description:
              'Voyez en un coup d’œil où en est chaque élève : progression du profil, candidatures et tâches encore ouvertes.',
          },
          {
            title: 'Profils de personnalité',
            description:
              'Comprenez mieux votre classe. Les profils psychométriques vous aident à personnaliser l’enseignement et à accompagner chaque élève là où il ou elle en est.',
          },
          {
            title: 'Tout le monde participe',
            description:
              'Parents, corps enseignant et élèves collaborent dans YourApplicant. Partagez les évaluations par des tiers, suivez les progrès et restez tous informés.',
          },
        ],
      },
      journey: {
        eyebrow: 'Plan d’études 21',
        title: 'Voici comment nous accompagnons votre classe',
        phases: [
          {
            phase: 'Phase 1',
            title: 'Réflexion personnelle',
            tags: ['Profil de personnalité'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Salut Luca, tu joues au football dans un club. As-tu déjà été capitaine ?',
              },
              {
                speaker: 'student',
                text: 'Oui, pendant une saison. Mais ce n’était rien de spécial.',
              },
              {
                speaker: 'anna',
                text: 'Au contraire. Comme capitaine, tu motives ton équipe et tu prends des décisions sous pression. C’est exactement le genre d’expérience qui doit figurer dans ton profil.',
              },
            ],
          },
          {
            phase: 'Phases 2 & 3',
            title: 'Motivation',
            tags: ['Choix professionnel', 'Matching'],
            dialogue: [
              {
                speaker: 'student',
                text: 'Je ne sais pas quel apprentissage choisir.',
              },
              {
                speaker: 'anna',
                text: 'Tu crées des sites web et tu aimes les jeux vidéo. As-tu déjà pensé à un métier technique, comme informaticien ?',
              },
              {
                speaker: 'student',
                text: 'Pas vraiment, mais ça a l’air intéressant.',
              },
              {
                speaker: 'anna',
                text: 'Veux-tu que je te montre à quoi ressemble une journée type dans l’informatique et pourquoi ce métier pourrait te correspondre ?',
              },
            ],
          },
          {
            phase: 'Phase 4',
            title: 'Documents',
            tags: [
              'CV',
              'Processus de candidature',
              'Postuler',
              'Matches',
              'Vivier de talents',
            ],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Salut Luca, c’est très réussi ! N’oublie pas de mentionner ton expérience de leadership comme capitaine de basketball.',
              },
            ],
          },
        ],
      },
      steps: {
        eyebrow: 'Plus simple qu’on ne le pense',
        title: 'Un accompagnement moderne en 3 étapes.',
        items: [
          {
            title: 'S’inscrire',
            description: 'Inscrire l’école et configurer son profil. 3 minutes.',
          },
          {
            title: 'Inviter',
            description: 'Créer les classes. Les élèves les rejoignent par code QR. 15 minutes.',
          },
          {
            title: 'Accompagner',
            description: 'Les élèves sont accompagnés automatiquement. Aucun travail supplémentaire.',
          },
        ],
      },
      faq: {
        eyebrow: 'Questions fréquentes',
        title: 'Vos questions, nos réponses.',
        contactLead: 'Vous avez des questions ? Planifiez un entretien gratuit',
        contactCta: 'Planifier un entretien gratuit',
        emailLead: 'ou écrivez-nous à',
        items: [
          {
            question: 'YourApplicant peut-il être intégré au Plan d’études 21 ?',
            answer:
              'Oui, YourApplicant est directement aligné sur le Plan d’études 21 et couvre toutes les activités essentielles des phases 1 à 4. YourApplicant aide en plus activement les élèves à postuler, un domaine que le corps enseignant n’a plus à prendre en charge.',
          },
          {
            question: 'Comment YourApplicant protège-t-il les données ?',
            answer:
              'Les profils sont protégés et ne sont pas accessibles au public. Les écoles et les élèves gardent le contrôle de leurs informations ; les données servent uniquement à l’accompagnement et à la recherche d’une place d’apprentissage et ne sont jamais vendues.',
          },
          {
            question: 'Combien de travail demande la mise en place ?',
            answer:
              'L’école est configurée en quelques minutes. Vous créez ensuite les classes et les élèves les rejoignent par code QR. Aucune installation ni formation complexe n’est nécessaire.',
          },
          {
            question: 'Sur quels appareils peut-on utiliser YourApplicant ?',
            answer:
              'YourApplicant fonctionne dans le navigateur sur ordinateur portable, tablette et smartphone. Les élèves et le corps enseignant peuvent donc utiliser les appareils déjà disponibles à l’école.',
          },
        ],
      },
    },
    companies: {
      hero: {
        eyebrow: 'Encore gratuit pour l’instant',
        title: 'Trouvez la personne qui correspond vraiment.',
        subtitle:
          'YourApplicant trouve des apprenti·es qui correspondent à votre entreprise et à sa culture, tant sur le plan professionnel qu’humain.',
        primaryCta: 'Commencer maintenant',
        secondaryCta: 'Planifier un entretien',
        applications: '+20 candidatures',
        fit: 'Leandro remplit 4/4 critères',
        requirements: [
          '3x jours de stage d’orientation dans le commerce',
          'Grande ouverture d’esprit & extraversion',
          'Moyenne générale de 5.1',
          'École secondaire niveau A',
        ],
      },
      features: {
        eyebrow: 'Pour les entreprises formatrices',
        title: 'Bien plus qu’une bourse d’emploi.',
        items: [
          {
            title: 'Explorez le vivier de talents.',
            description:
              'Recherchez des talents selon vos critères précis. Un clic suffit pour les contacter.',
          },
          {
            title: 'Votre place trouve les bonnes personnes.',
            description:
              'Définissez une fois qui vous recherchez. Les élèves qui correspondent à vos critères reçoivent votre place comme suggestion personnalisée.',
          },
          {
            title: 'Bien plus qu’un CV.',
            description:
              'Découvrez la personne derrière la candidature. Personnalité, expériences, points forts et regard extérieur en un coup d’œil.',
          },
          {
            title: 'Une communication qui fonctionne.',
            description:
              'Tout passe par YourApplicant. Fini le chaos des e-mails : tout est réuni au même endroit. Les élèves reçoivent automatiquement un rappel pour répondre.',
          },
        ],
      },
      recruiting: {
        eyebrow: 'Candidatures',
        title: 'Un recrutement sans chaos.',
        cta: 'Commencer',
        items: [
          {
            title: 'Des dossiers complets.',
            description:
              'Les élèves déposent des candidatures complètes et uniques. Plus aucun document manquant.',
          },
          {
            title: 'Un processus sur mesure',
            description:
              'Définissez vos propres statuts et gérez les candidatures selon vos processus internes.',
          },
          {
            title: 'Présélection en 10 secondes',
            description:
              'Toutes les informations importantes en un coup d’œil, avant même d’ouvrir un document.',
          },
        ],
        statusTitle: 'Nom du statut',
        statusLabels: [
          { label: 'Département', count: 7 },
          { label: 'Stages d’observation', count: 3 },
          { label: 'Entretien', count: 3 },
          { label: 'Refus', count: 8 },
          { label: 'Accord', count: 5 },
          { label: 'Rejet', count: 3 },
          { label: '2e entretien', count: 3 },
          { label: 'Présélection', count: 12 },
        ],
      },
      audiences: {
        eyebrow: 'Pour chaque entreprise',
        title: 'Pour toutes celles qui forment.',
        cta: 'Se lancer',
        items: [
          {
            title: 'PME',
            description:
              'Peu de temps et de ressources RH. Trouvez rapidement le profil le plus adapté, sans grands efforts.',
          },
          {
            title: 'Grandes entreprises',
            description:
              'De nombreuses candidatures et des processus complexes. Une gestion structurée qui s’intègre à vos processus existants.',
          },
          {
            title: 'Entreprises en manque de relève',
            description:
              'Des métiers qui peinent à attirer les jeunes. YourApplicant propose activement votre place aux élèves qui correspondent.',
          },
          {
            title: 'Entreprises qui recrutent très tôt les meilleurs talents',
            description:
              'Repérez les talents avant qu’ils ne s’engagent ailleurs. Contactez activement les bonnes personnes grâce au vivier de talents.',
          },
        ],
      },
      steps: {
        eyebrow: 'Plus simple qu’on ne le pense',
        title: 'La bonne personne en 3 étapes.',
        items: [
          {
            title: 'S’inscrire',
            description: 'Inscrire l’entreprise et configurer son profil. 3 minutes.',
          },
          {
            title: 'Publier',
            description: 'Saisir la place et définir les critères. 10 minutes.',
          },
          {
            title: 'Recevoir des candidatures',
            description:
              'Les élèves qui correspondent postulent directement auprès de vous, ou vous recherchez activement dans le vivier de talents.',
          },
        ],
      },
      faq: {
        eyebrow: 'Questions fréquentes',
        title: 'Vos questions, nos réponses.',
        items: [
          {
            question: 'Qu’est-ce que YourApplicant pour les entreprises ?',
            answer:
              'YourApplicant aide les entreprises formatrices à trouver des apprenti·es qui leur correspondent sur le plan professionnel comme humain. Vous recevez des candidatures complètes, pouvez explorer le vivier de talents et les élèves qui vous correspondent peuvent aussi vous trouver. Tout est réuni au même endroit, sans chaos dans les e-mails.',
          },
          {
            question: 'Combien coûte YourApplicant pour les entreprises ?',
            answer:
              'L’accès de base est gratuit. Vous pouvez publier une place d’apprentissage et recevoir des candidatures complètes sans rien payer. Pour rechercher activement dans le vivier de talents ou contacter directement les personnes souhaitées, choisissez l’une des offres payantes.',
          },
          {
            question: 'Combien de travail demande la mise en place ?',
            answer:
              'Très peu. En trois minutes environ, vous inscrivez votre entreprise et configurez son profil. Vous saisissez ensuite votre place d’apprentissage en dix minutes environ et recevez des candidatures adaptées. Pas de longue installation ni de formation nécessaire.',
          },
          {
            question: 'Comment YourApplicant aide-t-il en cas de manque de candidatures ?',
            answer:
              'Au lieu d’attendre que quelqu’un se manifeste, vous trouvez vous-mêmes les élèves adéquats dans le vivier de talents et les contactez directement. Votre place est aussi proposée automatiquement aux jeunes qui correspondent, même s’ils ne connaissent pas encore votre entreprise.',
          },
          {
            question: 'Les candidatures sont-elles complètes ?',
            answer:
              'Oui. Les élèves postulent avec un dossier complet qui présente leur personnalité, leurs points forts et leurs expériences. En quelques secondes, vous voyez si la personne correspond avant même d’ouvrir un document. Plus aucun dossier incomplet.',
          },
          {
            question: 'À quelles entreprises YourApplicant convient-il ?',
            answer:
              'À toute entreprise formatrice, de la PME disposant de peu de temps et de ressources RH à la grande entreprise qui reçoit de nombreuses candidatures. YourApplicant est particulièrement utile aux entreprises qui peinent à trouver de la relève ou souhaitent attirer les meilleurs talents très tôt.',
          },
        ],
      },
    },
    pricing: {
      hero: {
        eyebrow: 'Aperçu des tarifs',
        tabs: {
          companies: 'Entreprises',
          schools: 'Écoles',
        },
        title: 'Incroyablement simple. Incroyablement efficace.',
      },
      counterLabel: 'Nombre de places d’apprentissage',
      currency: 'CHF',
      period: '/ an',
      includedLabel: 'Ce qui est inclus',
      plans: [
        {
          name: 'Starter',
          price: '0',
          description:
            'Pour les PME. Démarrez facilement et recevez immédiatement des candidatures.',
          features: [
            { label: 'Annonces de places d’apprentissage attrayantes', available: true },
            { label: 'Aide à la création de l’annonce', available: true },
            { label: 'La place est proposée aux profils recherchés', available: false },
            { label: 'Présélectionner les candidatures en 10 secondes', available: true },
            { label: 'Des candidatures toujours complètes', available: true },
            { label: 'Un dossier personnel pour chaque candidat·e', available: true },
            { label: 'Toute la communication au même endroit', available: true },
            { label: 'Définir son propre processus de candidature', available: false },
            { label: 'Inviter son équipe', available: false },
            { label: 'Recherche dans le vivier de talents', available: false },
            { label: 'Contacter directement des candidat·es', available: false },
          ],
          cta: 'Commencer maintenant',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Essential',
          price: '240',
          description:
            'Pour les entreprises qui recrutent en équipe et souhaitent définir leurs propres processus.',
          features: [
            { label: 'Annonces de places d’apprentissage attrayantes', available: true },
            { label: 'Aide à la création de l’annonce', available: true },
            { label: 'La place est proposée aux profils recherchés', available: true },
            { label: 'Présélectionner les candidatures en 10 secondes', available: true },
            { label: 'Des candidatures toujours complètes', available: true },
            { label: 'Un dossier personnel pour chaque candidat·e', available: true },
            { label: 'Toute la communication au même endroit', available: true },
            { label: 'Définir son propre processus de candidature', available: true },
            { label: 'Inviter son équipe', available: true },
            { label: 'Recherche dans le vivier de talents', available: false },
            { label: 'Contacter directement des candidat·es', available: false },
          ],
          cta: 'Commencer maintenant',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Pro',
          price: '690',
          description:
            'Pour les entreprises qui recherchent activement des talents. Idéal pour attirer les meilleurs avant qu’ils ne soient plus disponibles.',
          features: [
            { label: 'Tout Essential inclus', available: true },
            { label: 'Recherche illimitée dans le vivier de talents', available: true },
            {
              label: 'Contacter directement les profils souhaités avant qu’il ne soit trop tard.',
              available: true,
            },
          ],
          cta: 'Commencer maintenant',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Enterprise',
          price: 'Sur demande',
          description:
            'Pour les grandes entreprises proposant 10+ places d’apprentissage.',
          features: [
            { label: 'Tout Pro inclus', available: true },
            { label: 'Interlocuteur personnel', available: true },
            { label: 'Processus d’intégration personnalisé', available: true },
            { label: 'Intégration aux systèmes existants', available: true },
          ],
          cta: 'Prendre contact',
          ctaState: { disabled: true, gated: true, minimumPositions: 10 },
          note: 'Disponible dès 10 places d’apprentissage.',
        },
      ],
      schoolsPanel: {
        eyebrow: 'Aperçu des tarifs',
        title: 'Conçu pour les écoles.',
        titleAccent: 'Accompagner simplement.',
        studentCountLabel: 'Nombre d’élèves',
        trialBadge: '3 mois d’essai gratuits',
        price: '20',
        currency: 'CHF',
        period: '/ an',
        perStudentLabel: 'par élève et par an',
        description:
          'Pour les écoles. Démarrez facilement et accompagnez chaque élève individuellement.',
        cta: 'Planifier un entretien',
        note:
          'Nous répondons ensemble à toutes vos questions et discutons des prochaines étapes.',
        features: [
          { label: 'Annonces de places d’apprentissage attrayantes', available: true },
          { label: 'Aide à la création de l’annonce', available: true },
          { label: 'Présélectionner les candidatures en 10 secondes', available: true },
          { label: 'Des candidatures toujours complètes', available: true },
          { label: 'Un dossier personnel pour chaque candidat·e', available: true },
          { label: 'Toute la communication au même endroit', available: true },
          { label: 'Définir son propre processus de candidature', available: true },
          { label: 'Inviter son équipe', available: true },
          { label: 'Recherche dans le vivier de talents', available: false },
          { label: 'Contacter directement des candidat·es', available: false },
        ],
      },
    },
    about: {
      hero: {
        title: 'Une place d’apprentissage adaptée change une vie.',
        subtitle:
          'Nous sommes convaincus qu’une véritable adéquation, tant sur le plan professionnel qu’humain, motive davantage les jeunes, leur permet de mieux déployer leur potentiel et d’apprendre plus. Elle leur offre un meilleur départ dans la vie et fait grandir les talents dont l’économie suisse a besoin.',
      },
      story: {
        title: 'La naissance de YourApplicant',
        description:
          'Devin Baucamp raconte son parcours, la naissance de YourApplicant et ce qui l’a poussé à lancer ce mouvement',
        videoAria: 'Lancer la vidéo sur l’histoire de YourApplicant',
      },
      team: {
        eyebrow: 'Les personnes à l’origine du projet',
        title: 'Notre équipe',
        members: [
          { name: 'Devin Baucamp', role: 'CEO & fondateur' },
          { name: 'Lubo Dilov', role: 'Développeur principal' },
          { name: 'Aleksander Dimitrov', role: 'Développeur frontend' },
          { name: 'Aleyna Arslan', role: 'Contenu & marketing' },
          { name: 'Samira Bannwart', role: 'Conseil consultatif & ventes' },
          { name: 'Leon Sarkis', role: 'Ventes & partenariats' },
        ],
      },
    },
    resources: {
      coach: {
        slug: '/coach',
        hero: {
          eyebrow: 'Gratuit pour les élèves',
          title: 'Ta coach personnelle.',
          titleAccent: 'Toujours à tes côtés.',
          subtitle:
            'Du choix du métier à l’obtention d’une place. Coach Anna te connaît, te comprend et t’accompagne à chaque étape.',
          cta: 'Commencer maintenant',
        },
        intro:
          'Tu n’as pas à trouver par toi-même le chemin vers ta place d’apprentissage. Coach Anna apprend à te connaître grâce à ton profil, répond à tes questions et te montre exactement la prochaine étape qui a du sens pour toi.',
        section: {
          title: 'Coach Anna t’accompagne',
          items: [
            {
              title: 'Elle apprend à te connaître.',
              description:
                'Grâce à ton profil, Coach Anna comprend tes centres d’intérêt, tes points forts et tes expériences.',
            },
            {
              title: 'Elle t’aide à réfléchir.',
              description:
                'Pose-lui toutes tes questions sur le choix d’un métier, ton dossier ou ta candidature. Tu reçois une réponse adaptée à ta situation.',
            },
            {
              title: 'Elle reste à tes côtés.',
              description:
                'De ta première idée à l’obtention d’une place, elle te rappelle ce qui compte pour la suite.',
            },
          ],
        },
        cta: {
          title: 'Découvre Coach Anna',
          subtitle: 'Un accompagnement gratuit, personnel et toujours disponible.',
          label: 'Commencer maintenant',
        },
        faq: {
          title: 'Questions fréquentes sur Coach Anna.',
          items: [
            {
              question: 'Qu’est-ce que Coach Anna ?',
              answer:
                'Coach Anna est ta coach personnelle sur YourApplicant. Elle connaît ton profil, répond à tes questions et t’accompagne du choix du métier à l’obtention d’une place, à tout moment et de manière entièrement personnalisée.',
            },
            {
              question: 'Que puis-je demander à Coach Anna ?',
              answer:
                'Tu peux lui poser toutes tes questions sur ton choix professionnel et ta recherche d’une place d’apprentissage : les métiers qui te correspondent, tes points forts, ton CV, ta lettre de motivation, tes candidatures ou un entretien à venir.',
            },
            {
              question: 'Coach Anna est-elle gratuite ?',
              answer:
                'Oui. Coach Anna et toutes les fonctionnalités de YourApplicant sont gratuites pour les élèves.',
            },
            {
              question: 'Coach Anna remplace-t-elle l’orientation professionnelle ?',
              answer:
                'Coach Anna complète le soutien de tes parents, de ton école et des services d’orientation professionnelle. Elle est disponible à tout moment et t’aide à préparer et à réaliser tes prochaines étapes.',
            },
          ],
        },
      },
      motivationLetter: {
        slug: '/motivationsschreiben-lehrstelle',
        hero: {
          eyebrow: 'Gratuit pour les élèves',
          title: 'Ta lettre de motivation.',
          titleAccent: 'Qui convainc.',
          subtitle:
            'Rédige en quelques minutes une lettre de motivation personnalisée pour ta place d’apprentissage.',
          cta: 'Commencer maintenant',
        },
        intro:
          'Une bonne lettre de motivation détermine souvent si tu seras invité à un entretien. Découvre ce que les entreprises formatrices recherchent et comment rédiger une lettre de motivation convaincante pour ta place d’apprentissage.',
        section: {
          title: 'Pour une lettre de motivation réussie',
          items: [
            {
              title: 'Explique pourquoi cette entreprise.',
              description:
                'Ne reste pas dans le général : explique ce qui t’attire précisément dans cette place d’apprentissage.',
            },
            {
              title: 'Donne un exemple concret.',
              description:
                'Un stage d’orientation, un loisir ou un projet qui te correspond et qui a un lien avec le métier.',
            },
            {
              title: 'Moins, c’est mieux.',
              description:
                'Une demi-page suffit. Mieux vaut un ou deux arguments sincères qu’une série de phrases creuses.',
            },
          ],
        },
        cta: {
          title: 'Créer ta lettre de motivation',
          subtitle: 'Avec Coach Anna. Gratuitement, en quelques minutes.',
          label: 'Créer ta lettre de motivation',
        },
        faq: {
          title: 'Questions fréquentes sur la lettre de motivation.',
          items: [
            {
              question: 'Quelle doit être la longueur d’une lettre de motivation ?',
              answer:
                'D’une demi-page à une page A4 au maximum. Les entreprises formatrices lisent de nombreuses candidatures, chaque phrase compte donc. Trois à quatre courts paragraphes suffisent largement.',
            },
            {
              question: 'Comment commencer une lettre de motivation ?',
              answer:
                'Indique dès la première phrase la place d’apprentissage pour laquelle tu postules et pourquoi elle t’intéresse. Évite les longues introductions et va droit au but.',
            },
            {
              question: 'Que faut-il mettre dans une lettre de motivation ?',
              answer:
                'Trois choses : pourquoi cette entreprise précisément, ce que tu apportes déjà — un stage d’orientation, un loisir ou tes points forts — et pourquoi ce métier te correspond. Termine par une courte phrase indiquant que tu te réjouis d’un entretien.',
            },
            {
              question:
                'Quelle est la différence entre une lettre de motivation et une lettre de candidature ?',
              answer:
                'En général, ces deux termes désignent la même chose. Les deux expliquent pourquoi tu postules à cette place d’apprentissage et pourquoi ton profil convient. Certaines entreprises parlent de lettre de motivation, d’autres de lettre de candidature.',
            },
          ],
        },
      },
      cv: {
        slug: '/lebenslauf-lehrstelle',
        hero: {
          eyebrow: 'Gratuit pour les élèves',
          title: 'Ton CV.',
          titleAccent: 'En quelques minutes.',
          subtitle:
            'Crée un CV clair pour ta place d’apprentissage, avec toutes les informations essentielles.',
          cta: 'Commencer maintenant',
        },
        intro:
          'Le CV est la première chose qu’une entreprise formatrice voit de toi. Découvre ce qu’un CV pour une place d’apprentissage doit contenir et comment en créer un qui soit clair et complet en quelques minutes.',
        section: {
          title: 'Pour un CV réussi',
          items: [
            {
              title: 'Le plus récent d’abord.',
              description:
                'Commence par ton école actuelle, puis remonte dans le temps. Les informations les plus récentes figurent en haut.',
            },
            {
              title: 'Montre ce qui te distingue.',
              description:
                'Choisis trois ou quatre vrais points forts plutôt qu’une longue liste. Mieux vaut en présenter quelques-uns qui te correspondent vraiment.',
            },
            {
              title: 'Mise sur la clarté.',
              description:
                'Une page, des rubriques claires et une bonne photo. Les entreprises formatrices se font une idée en quelques secondes.',
            },
          ],
        },
        cta: {
          title: 'Créer ton CV',
          subtitle: 'Avec Coach Anna. Gratuitement, en quelques minutes.',
          label: 'Créer ton CV',
        },
        faq: {
          title: 'Questions fréquentes sur le CV.',
          items: [
            {
              question: 'Que faut-il mettre dans un CV pour une place d’apprentissage ?',
              answer:
                'Tes coordonnées, ta formation scolaire, tes éventuels stages d’orientation, tes loisirs, tes langues et tes points forts. Ajoute une photo récente et soignée en haut du CV.',
            },
            {
              question: 'Quelle doit être la longueur d’un CV ?',
              answer:
                'Une page A4 suffit. En tant qu’élève, tu n’as pas encore une longue expérience professionnelle : ton CV doit donc rester court et clair.',
            },
            {
              question: 'Faut-il mettre une photo sur un CV ?',
              answer:
                'En Suisse, oui. Une bonne photo sobre fait partie d’une candidature complète. Choisis une photo sympathique et soignée, ni un selfie ni une photo de vacances.',
            },
            {
              question: 'Quelle est la différence entre un curriculum vitæ et un CV ?',
              answer:
                'Il n’y en a aucune. CV est l’abréviation de Curriculum Vitae et désigne exactement le même document.',
            },
          ],
        },
      },
      careerCheck: {
        slug: '/berufscheck',
        hero: {
          eyebrow: 'Gratuit pour les élèves',
          title: 'Quel métier',
          titleAccent: 'te correspond ?',
          subtitle:
            'Tu n’as pas à le découvrir par toi-même. Coach Anna t’accompagne jusqu’à ce que tu trouves le métier qui te correspond.',
          cta: 'Commencer maintenant',
        },
        intro:
          'Tu n’as aucune idée du métier que tu veux faire ? C’est tout à fait normal, et tu n’as pas à le découvrir par toi-même. Coach Anna apprend à te connaître grâce à ton profil, explore avec toi ce qui te correspond et t’accompagne pas à pas jusqu’à la place d’apprentissage adaptée.',
        section: {
          title: 'Coach Anna t’accompagne',
          items: [
            {
              title: 'Réponds à quelques questions.',
              description:
                'Grâce à quelques questions et à ton profil, Coach Anna comprend ce qui te caractérise et ce qui te convient.',
            },
            {
              title: 'Elle t’aide à réfléchir.',
              description:
                'Tu peux tout lui demander. Coach Anna t’aide à y voir clair, à ton rythme.',
            },
            {
              title: 'Elle te guide vers la place d’apprentissage adaptée.',
              description:
                'À partir de tout ce qu’elle sait de toi, elle te présente des métiers et des places d’apprentissage qui te correspondent vraiment.',
            },
          ],
        },
        cta: {
          title: 'Commencer maintenant',
          subtitle: 'Avec Coach Anna. Gratuitement, en quelques minutes.',
          label: 'Commencer maintenant',
        },
        faq: {
          title: 'Questions fréquentes sur le choix professionnel.',
          items: [
            {
              question: 'Comment savoir quel métier me correspond ?',
              answer:
                'Tu n’as pas à le découvrir par toi-même. Coach Anna t’accompagne pas à pas, apprend à connaître ton profil dans son ensemble et t’aide à trouver le métier qui te correspond vraiment. Le test n’est qu’un point de départ.',
            },
            {
              question: 'Qu’est-ce que Coach Anna ?',
              answer:
                'Coach Anna est ta coach personnelle sur YourApplicant. Elle connaît ton profil, répond à tes questions et t’accompagne du choix du métier à l’obtention d’une place, à tout moment et de manière entièrement personnalisée.',
            },
            {
              question: 'Et si je n’ai encore aucune idée de ce que je veux faire ?',
              answer:
                'C’est précisément pour cela que YourApplicant existe. Tu n’as pas besoin d’avoir déjà les réponses quand tu commences. Coach Anna explore avec toi ce qui te correspond et ce qui t’intéresse, puis t’aide à y voir plus clair pas à pas.',
            },
          ],
        },
      },
      apprenticeships: {
        slug: '/lehrstellen',
        hero: {
          eyebrow: 'Gratuit pour les élèves',
          title: 'Trouve des places d’apprentissage',
          titleAccent: 'qui te correspondent.',
          subtitle:
            'Ne parcours pas des centaines d’annonces. YourApplicant te présente les places d’apprentissage disponibles qui te correspondent vraiment.',
          cta: 'Découvrir les places d’apprentissage',
        },
        intro:
          'Il existe des milliers de places d’apprentissage disponibles. Mais laquelle te correspond ? Au lieu de parcourir toutes les annonces, YourApplicant te propose des places proches de chez toi qui correspondent à ta personnalité et à tes points forts.',
        section: {
          title: 'Comment trouver ta place d’apprentissage',
          items: [
            {
              title: 'Dis-nous ce qui te caractérise.',
              description:
                'Grâce à ton profil, YourApplicant apprend à connaître tes points forts, tes centres d’intérêt et ta région.',
            },
            {
              title: 'Découvre les places qui te correspondent.',
              description:
                'Tu reçois des suggestions de places qui te correspondent vraiment au lieu d’une liste interminable.',
            },
            {
              title: 'Fais-toi repérer.',
              description:
                'Les entreprises formatrices découvrent ton profil et prennent directement contact avec toi.',
            },
          ],
        },
        cta: {
          title: 'Découvrir les places d’apprentissage',
          subtitle: 'Avec Coach Anna. Gratuitement, en quelques minutes.',
          label: 'Découvrir les places d’apprentissage',
        },
        faq: {
          title: 'Questions fréquentes sur la recherche d’une place d’apprentissage',
          items: [
            {
              question: 'Où trouver des places d’apprentissage disponibles en Suisse ?',
              answer:
                'Tu trouveras des places disponibles sur différentes plateformes. YourApplicant va plus loin en te proposant de manière ciblée celles qui correspondent à ta personnalité et à tes points forts, près de chez toi.',
            },
            {
              question: 'Quand dois-je commencer à chercher une place d’apprentissage ?',
              answer:
                'En général, environ un an avant le début de l’apprentissage, souvent en 3e année du secondaire I. Certaines entreprises attribuent leurs places tôt, mieux vaut donc commencer à temps.',
            },
            {
              question: 'Combien de places d’apprentissage dois-je examiner ?',
              answer:
                'Mieux vaut quelques places qui te correspondent vraiment que cent places choisies au hasard. Quand une place te convient, tes chances de réussir le processus de candidature augmentent aussi.',
            },
            {
              question: 'Et si je ne sais pas encore quel métier je veux faire ?',
              answer:
                'Aucun problème. Commence par le bilan d’orientation. YourApplicant découvre d’abord ce qui te correspond, puis te présente des places d’apprentissage adaptées.',
            },
          ],
        },
      },
    },
  },
  en: {
    localeName: 'English',
    document: {
      titleSuffix: 'YourApplicant',
      pageTitles: {
        home: 'Students',
        schools: 'Schools',
        companies: 'Companies',
        pricing: 'Pricing',
        about: 'About Us',
        coach: 'Coach Anna',
        motivationLetter: 'Cover Letter',
        cv: 'CV',
        careerCheck: 'Career Check',
        apprenticeships: 'Apprenticeships',
      },
    },
    common: {
      nav: {
        students: 'Students',
        schools: 'Schools',
        companies: 'Companies',
        pricing: 'Pricing',
        about: 'About Us',
      },
      actions: {
        login: 'Sign in',
        start: 'Get Started',
        startLower: 'Get started',
        discover: 'Discover',
        create: 'Create yours',
        beFound: 'Get discovered',
        apply: 'Apply',
        register: 'Register',
        viewPricing: 'View pricing',
        bookCall: 'Book a call',
        bookFreeCall: 'Book a free call',
        contact: 'Contact us',
        meetCoach: 'Meet your coach',
        exploreJobs: 'Explore apprenticeships',
        createLetter: 'Create your cover letter',
        createCv: 'Create your CV',
        backHome: 'Back to home',
      },
      labels: {
        scroll: 'Scroll',
        online: 'Online',
      },
      aria: {
        home: 'YourApplicant home',
        mainNavigation: 'Main navigation',
        toggleNavigation: 'Toggle navigation',
        openNavigation: 'Open navigation',
        closeNavigation: 'Close navigation',
        selectLanguage: 'Select language',
        languageMenu: 'Language selection',
        skipToContent: 'Skip to content',
        scrollToContent: 'Scroll to the next section',
        previousSlide: 'Previous slide',
        nextSlide: 'Next slide',
        pauseAnimation: 'Pause animation',
        playAnimation: 'Play animation',
        studentStories: 'Success stories from apprentices',
        productPreview: 'Preview of the YourApplicant app',
        teacherDashboard: 'YourApplicant dashboard for teachers',
        candidatePreview: 'Preview of a candidate profile',
        decreasePositions: 'Decrease number of apprenticeship positions',
        increasePositions: 'Increase number of apprenticeship positions',
        openFaq: 'Open answer',
        closeFaq: 'Close answer',
        externalLink: 'Opens in a new tab',
        loading: 'Loading content',
      },
      footer: {
        description:
          'YourApplicant helps students, schools and employers find the right apprenticeship – professionally and personally.',
        pagesTitle: 'Pages',
        informationTitle: 'Information',
        contactTitle: 'Contact',
        pages: {
          students: 'Students',
          schools: 'Schools',
          companies: 'Companies',
          pricing: 'Pricing',
          about: 'About Us',
        },
        resources: {
          motivationLetter: 'Cover Letter',
          cv: 'CV',
          careerCheck: 'Career Check',
          apprenticeships: 'Apprenticeships',
        },
        address: 'Bahnhofstrasse 1, 8001 Zurich',
        copyright: '© 2026 YourApplicant. All rights reserved.',
        createdBy: 'Created by',
      },
    },
    home: {
      hero: {
        eyebrow: 'Free for students',
        title: 'The simplest way to an apprenticeship',
        subtitle: 'The simplest way to the apprenticeship that truly fits you.',
        cta: 'Get Started',
        proof: 'Recommended by apprentices',
      },
      stories: {
        ariaLabel: 'Success stories from apprentices',
        cardLabel: 'My match',
      },
      ribbon: 'Your profile. Every opportunity.',
      dossier: {
        eyebrow: 'Application file',
        title: 'Fill it in once.',
        titleAccent: 'Apply anytime.',
        description:
          'Create your application file once and send every application in under five minutes, with a profile that truly stands out.',
        cta: 'Create yours',
      },
      talentPool: {
        eyebrow: 'Talent pool',
        title: 'Don’t just apply.',
        titleAccent: 'Get discovered.',
        description:
          'Training companies discover your profile and contact you directly because you are exactly who they are looking for.',
        cta: 'Get discovered',
        notification: 'UBS AG would like to meet you',
      },
      matches: {
        eyebrow: 'Apprenticeship matches',
        title: 'The right apprenticeships.',
        titleAccent: 'Straight to you.',
        description:
          'You don’t have to search alone. YourApplicant automatically finds the apprenticeships that fit you.',
        companyLine: 'Apprenticeship at YourApplicant in Zurich as',
        role: 'Commercial Employee (Tourism) EFZ',
        year: '2026',
        strength: 'Strong match',
        reasonTitle: 'Why YOU fit',
        reason:
          'You enjoy working with people and are interested in travel and other cultures. Your commitment to volleyball and your work at the school festival show that you are a team player who takes responsibility. Your class teacher describes you as open and communicative. With two commercial trial apprenticeships and an average grade of 5.1, you are exactly what YourApplicant is looking for.',
        apply: 'Apply',
      },
      journey: {
        eyebrow: 'Hello!',
        quote:
          'From the first “What do I actually want to be?” to a signed apprenticeship contract. Why make it hard when it can be simple?',
        pills: [
          'Personality profile',
          'Career guidance',
          'Coach Anna',
          'Applications',
          'Matches',
          'Talent pool',
        ],
      },
      coach: {
        eyebrow: 'Coach Anna',
        title: 'Your personal coach.',
        titleAccent: 'Always with you.',
        description:
          'From choosing a career to receiving an offer. Coach Anna knows you, understands you and has an answer for every question.',
        cta: 'Get started',
      },
      faq: {
        eyebrow: 'Frequently asked questions',
        title: 'Your questions, answered.',
        items: [
          {
            question: 'What is YourApplicant?',
            answer:
              'YourApplicant is a free platform for students in Switzerland looking for an apprenticeship. You create your profile once, find suitable apprenticeships and get discovered by training companies. Coach Anna guides you from your first step to an offer.',
          },
          {
            question: 'Is YourApplicant really free?',
            answer:
              'Yes. YourApplicant is completely free for students. You can create your application file, apply and use Coach Anna without paying anything.',
          },
          {
            question: 'When should I start looking for an apprenticeship?',
            answer:
              'Ideally, about a year before the apprenticeship begins. Mid to late summer break is a good time to start applying, as many companies publish their positions then. Wherever you are today, Coach Anna meets you there and shows you what to do next.',
          },
          {
            question: 'How do I find an apprenticeship that suits me?',
            answer:
              'Build your profile with your strengths and interests, and YourApplicant suggests apprenticeships that genuinely suit you. Instead of browsing hundreds of listings, you immediately see what fits.',
          },
          {
            question: 'What does YourApplicant offer beyond regular job boards?',
            answer:
              'Regular portals show you every apprenticeship. YourApplicant shows you the ones that fit, helps with your application and lets training companies discover you. You don’t just apply – you get found too.',
          },
          {
            question: 'Who can see my profile?',
            answer:
              'Only training companies that could be a good match – and only if you want them to. You remain in control of who sees you and when you apply.',
          },
        ],
      },
      closing: {
        eyebrow: 'Your future',
        title: 'Ready for your next step?',
        description:
          'Your future doesn’t begin with a perfect application. It begins with the first step.',
        cta: 'Get started',
      },
    },
    schools: {
      hero: {
        eyebrow: 'Curriculum 21 compliant',
        title: 'A personal path into working life',
        subtitle:
          'YourApplicant guides every student individually on their path into working life.',
        primaryCta: 'Get Started',
        secondaryCta: 'Book a call',
      },
      overview: {
        eyebrow: 'Why modern schools choose us.',
        title: 'Less work for teachers. More impact for students.',
        features: [
          {
            title: 'Class overview',
            description:
              'See everyone’s progress at a glance: profile completion, application activity and open tasks for every student.',
          },
          {
            title: 'Personality profiles',
            description:
              'Understand your class better. Psychometric profiles help you tailor lessons and support every student where they are.',
          },
          {
            title: 'Everyone involved',
            description:
              'Parents, teachers and students work together in YourApplicant. Share outside perspectives, track progress and stay on the same page.',
          },
        ],
      },
      journey: {
        eyebrow: 'Curriculum 21',
        title: 'How we guide your class',
        phases: [
          {
            phase: 'Phase 1',
            title: 'Self-reflection',
            tags: ['Personality profile'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Hey Luca, you play football for a club. Have you ever been captain?',
              },
              {
                speaker: 'student',
                text: 'Yes, for one season. But it wasn’t anything special.',
              },
              {
                speaker: 'anna',
                text: 'It was. As captain, you motivate your team and make decisions under pressure. That belongs in your profile.',
              },
            ],
          },
          {
            phase: 'Phases 2 & 3',
            title: 'Motivation',
            tags: ['Career choice', 'Matching'],
            dialogue: [
              {
                speaker: 'student',
                text: 'I don’t know which apprenticeship I should choose.',
              },
              {
                speaker: 'anna',
                text: 'You build websites and enjoy gaming. Have you considered a technical career such as IT?',
              },
              {
                speaker: 'student',
                text: 'Not really, but that sounds interesting.',
              },
              {
                speaker: 'anna',
                text: 'Would you like me to show you a typical day in IT and why the career could suit you?',
              },
            ],
          },
          {
            phase: 'Phase 4',
            title: 'Documents',
            tags: ['CV', 'Application process', 'Applying', 'Matches', 'Talent pool'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Hey Luca, this looks great! Don’t forget to mention your leadership experience as basketball captain.',
              },
            ],
          },
        ],
      },
      steps: {
        eyebrow: 'Simpler than you think',
        title: 'Modern guidance in three steps.',
        items: [
          {
            title: 'Register',
            description: 'Register your school and set up its profile. 3 minutes.',
          },
          {
            title: 'Invite',
            description: 'Create classes. Students join by QR code. 15 minutes.',
          },
          {
            title: 'Guide',
            description: 'Students receive automatic guidance. No extra workload.',
          },
        ],
      },
      faq: {
        eyebrow: 'Frequently asked questions',
        title: 'Your questions, answered.',
        contactLead: 'Have a question? Arrange a free consultation',
        contactCta: 'Book a free consultation',
        emailLead: 'or email us at',
        items: [
          {
            question: 'Can YourApplicant be integrated into Curriculum 21?',
            answer:
              'Yes. YourApplicant is aligned with Curriculum 21 and covers the key activities in phases 1 to 4. It also actively supports students with their applications – an area teachers no longer have to manage on their own.',
          },
          {
            question: 'How does YourApplicant handle data privacy?',
            answer:
              'Profiles are protected and not publicly accessible. Schools and students remain in control of their information; data is used only for guidance and the apprenticeship search, and is never sold.',
          },
          {
            question: 'How much work is the setup?',
            answer:
              'A school can be set up in just a few minutes. You then create classes and students join by QR code. There is nothing to install and no lengthy training is required.',
          },
          {
            question: 'Which devices support YourApplicant?',
            answer:
              'YourApplicant runs in the browser on laptops, tablets and smartphones, so students and teachers can use the devices already available at school.',
          },
        ],
      },
    },
    companies: {
      hero: {
        eyebrow: 'Free for now',
        title: 'Find the person who truly fits.',
        subtitle:
          'YourApplicant finds apprentices who fit not only the role, but also your company and culture as people.',
        primaryCta: 'Get Started',
        secondaryCta: 'Book a call',
        applications: '20+ applications',
        fit: 'Leandro meets 4/4 requirements',
        requirements: [
          '3 commercial trial apprenticeships',
          'Highly open & outgoing',
          'Average grade of 5.1',
          'Secondary school, level A',
        ],
      },
      features: {
        eyebrow: 'For training companies',
        title: 'More than another job board.',
        items: [
          {
            title: 'Search the talent pool.',
            description:
              'Find talent using your specific requirements. Make contact in one click.',
          },
          {
            title: 'Your vacancy finds the right people.',
            description:
              'Define who you need once. Suitable students receive your vacancy as a personal recommendation.',
          },
          {
            title: 'More than a CV.',
            description:
              'Meet the person behind the application. See personality, experience, strengths and outside feedback at a glance.',
          },
          {
            title: 'Communication that works.',
            description:
              'Everything runs through YourApplicant. No email chaos, everything in one place. Students are reminded to reply automatically.',
          },
        ],
      },
      recruiting: {
        eyebrow: 'Applications',
        title: 'Recruiting without the chaos.',
        cta: 'Get started',
        items: [
          {
            title: 'Complete applications.',
            description:
              'Students apply with complete, individual profiles. No more missing documents.',
          },
          {
            title: 'Your own process',
            description:
              'Define custom statuses and manage applications around your internal workflow.',
          },
          {
            title: 'Screen in 10 seconds',
            description:
              'See all the important information at a glance, before opening a single document.',
          },
        ],
        statusTitle: 'Status name',
        statusLabels: [
          { label: 'Department', count: 7 },
          { label: 'Trial days', count: 3 },
          { label: 'Interview', count: 3 },
          { label: 'Declined', count: 8 },
          { label: 'Offer', count: 5 },
          { label: 'Rejected', count: 3 },
          { label: 'Second interview', count: 3 },
          { label: 'Screening', count: 12 },
        ],
      },
      audiences: {
        eyebrow: 'For every employer',
        title: 'For everyone who trains apprentices.',
        cta: 'Get started',
        items: [
          {
            title: 'SMEs',
            description:
              'Little time and lean HR resources. Find the most suitable candidate quickly, without a heavy process.',
          },
          {
            title: 'Large companies',
            description:
              'High application volumes and complex processes. Structured management that fits your existing workflows.',
          },
          {
            title: 'Companies short of young talent',
            description:
              'For careers that struggle to attract young people. YourApplicant actively recommends your vacancy to suitable students.',
          },
          {
            title: 'Companies that secure top talent early',
            description:
              'Identify talent before it is taken. Proactively approach the right people through the talent pool.',
          },
        ],
      },
      steps: {
        eyebrow: 'Simpler than you think',
        title: 'The right apprentice in three steps.',
        items: [
          {
            title: 'Register',
            description: 'Register your company and set up its profile. 3 minutes.',
          },
          {
            title: 'Publish',
            description: 'Create a vacancy and define your requirements. 10 minutes.',
          },
          {
            title: 'Receive applications',
            description:
              'Suitable students apply directly, or you search proactively in the talent pool.',
          },
        ],
      },
      faq: {
        eyebrow: 'Frequently asked questions',
        title: 'Your questions, answered.',
        items: [
          {
            question: 'What is YourApplicant for employers?',
            answer:
              'YourApplicant helps training companies find apprentices who fit both professionally and personally. You receive complete applications, can search the talent pool and are discovered by suitable students. Everything is in one place, without email chaos.',
          },
          {
            question: 'What does YourApplicant cost for employers?',
            answer:
              'Getting started is free. You can publish one apprenticeship and receive complete applications at no cost. To search the talent pool proactively or contact preferred candidates directly, choose one of the paid plans.',
          },
          {
            question: 'How much work is the setup?',
            answer:
              'Very little. Register your company and set up its profile in around three minutes. Then create your vacancy in about ten minutes and start receiving suitable applications. No lengthy setup or training required.',
          },
          {
            question: 'How does YourApplicant help when applications are scarce?',
            answer:
              'Instead of waiting, you can find suitable students in the talent pool and contact them directly. Your vacancy is also recommended automatically to young people who fit, even if they do not know your company yet.',
          },
          {
            question: 'Are applications complete?',
            answer:
              'Yes. Students apply with a complete file that shows their personality, strengths and experience. You can see whether someone fits in seconds, before opening a document. No more missing paperwork.',
          },
          {
            question: 'Which employers is YourApplicant for?',
            answer:
              'Any company that trains apprentices – from SMEs with little time and lean HR teams to large companies handling many applications. It is especially valuable for employers struggling to find young talent or hoping to secure the best candidates early.',
          },
        ],
      },
    },
    pricing: {
      hero: {
        eyebrow: 'Pricing overview',
        tabs: {
          companies: 'Companies',
          schools: 'Schools',
        },
        title: 'Incredibly Simple. Incredibly Good.',
      },
      counterLabel: 'Number of apprenticeships',
      currency: 'CHF',
      period: '/ year',
      includedLabel: 'What’s included',
      plans: [
        {
          name: 'Starter',
          price: '0',
          description: 'For SMEs. Start easily and receive applications right away.',
          features: [
            { label: 'Attractive apprenticeship listings', available: true },
            { label: 'Help creating your listing', available: true },
            { label: 'Vacancy recommended to preferred candidates', available: false },
            { label: 'Screen applications in 10 seconds', available: true },
            { label: 'Applications are always complete', available: true },
            { label: 'Personal file for every applicant', available: true },
            { label: 'All communication in one place', available: true },
            { label: 'Define your own application process', available: false },
            { label: 'Invite your team', available: false },
            { label: 'Talent pool search', available: false },
            { label: 'Contact candidates directly', available: false },
          ],
          cta: 'Get started',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Essential',
          price: '240',
          description: 'For teams that recruit together and need their own workflows.',
          features: [
            { label: 'Attractive apprenticeship listings', available: true },
            { label: 'Help creating your listing', available: true },
            { label: 'Vacancy recommended to preferred candidates', available: true },
            { label: 'Screen applications in 10 seconds', available: true },
            { label: 'Applications are always complete', available: true },
            { label: 'Personal file for every applicant', available: true },
            { label: 'All communication in one place', available: true },
            { label: 'Define your own application process', available: true },
            { label: 'Invite your team', available: true },
            { label: 'Talent pool search', available: false },
            { label: 'Contact candidates directly', available: false },
          ],
          cta: 'Get started',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Pro',
          price: '690',
          description:
            'For companies that search proactively. Secure the best talent before it is taken.',
          features: [
            { label: 'Everything in Essential', available: true },
            { label: 'Unlimited talent pool search', available: true },
            {
              label: 'Contact preferred candidates directly before they are taken.',
              available: true,
            },
          ],
          cta: 'Get started',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Enterprise',
          price: 'On request',
          description: 'For large companies with 10+ apprenticeships.',
          features: [
            { label: 'Everything in Pro', available: true },
            { label: 'Dedicated contact person', available: true },
            { label: 'Tailored onboarding process', available: true },
            { label: 'Integration with existing systems', available: true },
          ],
          cta: 'Contact us',
          ctaState: { disabled: true, gated: true, minimumPositions: 10 },
          note: 'Available from 10 apprenticeship positions.',
        },
      ],
      schoolsPanel: {
        eyebrow: 'Pricing overview',
        title: 'Built for Schools.',
        titleAccent: 'Guidance Made Simple.',
        studentCountLabel: 'Number of students',
        trialBadge: 'Try free for 3 months',
        price: '20',
        currency: 'CHF',
        period: '/ year',
        perStudentLabel: 'per student per year',
        description:
          'For schools. Get started easily and guide every student individually.',
        cta: 'Book a call',
        note:
          'We’ll answer every open question together and discuss the next steps.',
        features: [
          { label: 'Attractive apprenticeship listings', available: true },
          { label: 'Help creating your listing', available: true },
          { label: 'Screen applications in 10 seconds', available: true },
          { label: 'Applications are always complete', available: true },
          { label: 'Personal file for every applicant', available: true },
          { label: 'All communication in one place', available: true },
          { label: 'Define your own application process', available: true },
          { label: 'Invite your team', available: true },
          { label: 'Talent pool search', available: false },
          { label: 'Contact candidates directly', available: false },
        ],
      },
    },
    about: {
      hero: {
        title: 'The right apprenticeship can change a life.',
        subtitle:
          'We believe a genuine professional and personal match makes young people more motivated, helps them realise their potential and lets them learn more. It means a better start in life – and the young talent the Swiss economy needs.',
      },
      story: {
        title: 'How YourApplicant began',
        description:
          'Devin Baucamp shares his own story, how YourApplicant came to life and the motivation behind the movement',
        videoAria: 'Play the story of YourApplicant',
      },
      team: {
        eyebrow: 'The people behind it',
        title: 'Our team',
        members: [
          { name: 'Devin Baucamp', role: 'CEO & Founder' },
          { name: 'Lubo Dilov', role: 'Lead Developer' },
          { name: 'Aleksander Dimitrov', role: 'Frontend Developer' },
          { name: 'Aleyna Arslan', role: 'Content & Marketing' },
          { name: 'Samira Bannwart', role: 'Advisor & Sales' },
          { name: 'Leon Sarkis', role: 'Sales & Partnerships' },
        ],
      },
    },
    resources: {
      coach: {
        slug: '/coach',
        hero: {
          eyebrow: 'Free for students',
          title: 'Your personal coach.',
          titleAccent: 'Always with you.',
          subtitle:
            'From choosing a career to receiving an offer. Coach Anna knows you, understands you and guides every step.',
          cta: 'Get started',
        },
        intro:
          'You do not have to work out your path to an apprenticeship alone. Coach Anna gets to know you through your profile, answers your questions and shows you the next useful step.',
        section: {
          title: 'Coach Anna guides you',
          items: [
            {
              title: 'She gets to know you.',
              description:
                'Your profile helps Coach Anna understand your interests, strengths and experience.',
            },
            {
              title: 'She thinks things through with you.',
              description:
                'Ask anything about career choices, your file or an application. You receive an answer that fits you.',
            },
            {
              title: 'She stays by your side.',
              description:
                'From your first idea to an offer, she reminds you what matters next.',
            },
          ],
        },
        cta: {
          title: 'Meet Coach Anna',
          subtitle: 'Free, personal and always there when you need her.',
          label: 'Get started',
        },
        faq: {
          title: 'Frequently asked questions about Coach Anna.',
          items: [
            {
              question: 'What is Coach Anna?',
              answer:
                'Coach Anna is your personal guide at YourApplicant. She knows your profile, answers your questions and supports you from choosing a career to receiving an offer, whenever you need her and tailored to you.',
            },
            {
              question: 'What can I ask Coach Anna?',
              answer:
                'You can ask anything about choosing a career and finding an apprenticeship: suitable careers, your strengths, your CV, cover letters, applications or an upcoming interview.',
            },
            {
              question: 'Is Coach Anna free?',
              answer:
                'Yes. Coach Anna and every YourApplicant feature are free for students.',
            },
            {
              question: 'Does Coach Anna replace career counselling?',
              answer:
                'Coach Anna complements the support you receive from parents, school and career counsellors. She is always available and helps you prepare and carry out your next steps.',
            },
          ],
        },
      },
      motivationLetter: {
        slug: '/motivationsschreiben-lehrstelle',
        hero: {
          eyebrow: 'Free for students',
          title: 'Your cover letter.',
          titleAccent: 'Made to convince.',
          subtitle:
            'Write a cover letter for your apprenticeship in minutes – one that genuinely sounds like you.',
          cta: 'Get Started',
        },
        intro:
          'A good cover letter often determines whether you are invited to an interview. Learn what training companies look for and how to create an apprenticeship cover letter that makes a strong case for you.',
        section: {
          title: 'How to write a strong cover letter',
          items: [
            {
              title: 'Show why this company.',
              description:
                'Be specific about what appeals to you in this exact apprenticeship, rather than writing in general terms.',
            },
            {
              title: 'Share a real example.',
              description:
                'Mention a trial apprenticeship, hobby or project that connects you with the career.',
            },
            {
              title: 'Less is more.',
              description:
                'Half a page is enough. One or two genuine points are stronger than a page of empty phrases.',
            },
          ],
        },
        cta: {
          title: 'Create your cover letter',
          subtitle: 'With Coach Anna. Free, in just a few minutes.',
          label: 'Create your cover letter',
        },
        faq: {
          title: 'Frequently asked questions about cover letters.',
          items: [
            {
              question: 'How long should a cover letter be?',
              answer:
                'Half a page to one full A4 page at most. Training companies read many applications, so every sentence counts. Three or four short paragraphs are plenty.',
            },
            {
              question: 'How should I begin a cover letter?',
              answer:
                'Say which apprenticeship you are applying for and why it interests you in the first sentence. Skip the long introduction and get straight to the point.',
            },
            {
              question: 'What belongs in a cover letter?',
              answer:
                'Three things: why this company, what you already bring – a trial apprenticeship, hobby or strengths – and why the career suits you. Close with a short sentence saying you look forward to an interview.',
            },
            {
              question: 'What is the difference between a motivation letter and a cover letter?',
              answer:
                'In this context, they usually mean the same thing. Both explain why you are applying for the apprenticeship and why you are a good fit. Companies simply use different names.',
            },
          ],
        },
      },
      cv: {
        slug: '/lebenslauf-lehrstelle',
        hero: {
          eyebrow: 'Free for students',
          title: 'Your CV.',
          titleAccent: 'Ready in minutes.',
          subtitle:
            'Create a clean apprenticeship CV that shows everything a training company needs to know.',
          cta: 'Get Started',
        },
        intro:
          'Your CV is the first thing a training company sees. Learn what an apprenticeship CV should include and create a clean, complete version in just a few minutes.',
        section: {
          title: 'How to make your CV work',
          items: [
            {
              title: 'Put the newest first.',
              description:
                'Start with your current school, then work backwards. The most recent information belongs at the top.',
            },
            {
              title: 'Show what makes you you.',
              description:
                'Choose three or four genuine strengths instead of a long list. A few that truly fit you say more.',
            },
            {
              title: 'Keep it clear.',
              description:
                'One page, clear sections and a good photo. Training companies often decide in seconds.',
            },
          ],
        },
        cta: {
          title: 'Create your CV',
          subtitle: 'With Coach Anna. Free, in just a few minutes.',
          label: 'Create your CV',
        },
        faq: {
          title: 'Frequently asked questions about CVs.',
          items: [
            {
              question: 'What belongs in an apprenticeship CV?',
              answer:
                'Your personal details, education, any trial apprenticeships, hobbies, languages and strengths. Add a recent, friendly photo near the top.',
            },
            {
              question: 'How long should a CV be?',
              answer:
                'One A4 page is enough. As a student, you will not have years of professional experience yet, so keep your CV short and easy to scan.',
            },
            {
              question: 'Does a CV need a photo?',
              answer:
                'In Switzerland, yes. A good, neutral photo is part of a complete application. Keep it friendly and neat – not a selfie or a holiday picture.',
            },
            {
              question: 'What is the difference between a résumé and a CV?',
              answer:
                'For an apprenticeship application in Switzerland, there is no practical difference. Both names refer to the short document summarising your education, skills and experience.',
            },
          ],
        },
      },
      careerCheck: {
        slug: '/berufscheck',
        hero: {
          eyebrow: 'Free for students',
          title: 'Which career',
          titleAccent: 'fits you?',
          subtitle:
            'You don’t have to work it out alone. Coach Anna guides you until you find a career that fits.',
          cta: 'Get started',
        },
        intro:
          'No idea what you want to be? That is completely normal, and you do not have to figure it out alone. Coach Anna gets to know you through your profile, explores what suits you and guides you step by step to the right apprenticeship.',
        section: {
          title: 'Coach Anna guides you',
          items: [
            {
              title: 'Answer a few questions.',
              description:
                'A few questions and your profile help Coach Anna understand what makes you tick and what suits you.',
            },
            {
              title: 'She thinks things through with you.',
              description:
                'You can ask her anything. Coach Anna helps you find clarity at your own pace.',
            },
            {
              title: 'She leads you to the right apprenticeship.',
              description:
                'Using everything she knows about you, she shows you careers and apprenticeships that genuinely fit.',
            },
          ],
        },
        cta: {
          title: 'Get started',
          subtitle: 'With Coach Anna. Free, in just a few minutes.',
          label: 'Get started',
        },
        faq: {
          title: 'Frequently asked questions about choosing a career.',
          items: [
            {
              question: 'How do I find out which career suits me?',
              answer:
                'You do not have to work it out alone. Coach Anna guides you step by step, gets to know your whole profile and helps you find the career that truly fits. The test is only the beginning.',
            },
            {
              question: 'What is Coach Anna?',
              answer:
                'Coach Anna is your personal guide at YourApplicant. She knows your profile, answers your questions and supports you from choosing a career to receiving an offer, whenever you need her and tailored to you.',
            },
            {
              question: 'What if I have no idea what I want yet?',
              answer:
                'That is exactly what YourApplicant is for. You do not need any answers when you begin. Coach Anna explores what suits and interests you, helping you find clarity one step at a time.',
            },
          ],
        },
      },
      apprenticeships: {
        slug: '/lehrstellen',
        hero: {
          eyebrow: 'Free for students',
          title: 'Find apprenticeships',
          titleAccent: 'that fit you.',
          subtitle:
            'Don’t search through hundreds of listings. YourApplicant shows you open apprenticeships that genuinely fit.',
          cta: 'Explore apprenticeships',
        },
        intro:
          'There are thousands of open apprenticeships. But which one fits you? Instead of clicking through every listing, YourApplicant recommends opportunities near you that suit your personality and strengths.',
        section: {
          title: 'How to find your apprenticeship',
          items: [
            {
              title: 'Tell us what makes you you.',
              description:
                'Your profile helps YourApplicant learn your strengths, interests and preferred region.',
            },
            {
              title: 'See suitable apprenticeships.',
              description:
                'You receive suggestions that genuinely fit instead of facing an endless list.',
            },
            {
              title: 'Get discovered.',
              description:
                'Training companies discover your profile and contact you directly.',
            },
          ],
        },
        cta: {
          title: 'Explore apprenticeships',
          subtitle: 'With Coach Anna. Free, in just a few minutes.',
          label: 'Explore apprenticeships',
        },
        faq: {
          title: 'Frequently asked questions about apprenticeship searches',
          items: [
            {
              question: 'Where can I find open apprenticeships in Switzerland?',
              answer:
                'You can find openings on several portals. YourApplicant goes further by recommending apprenticeships that match your personality, strengths and location.',
            },
            {
              question: 'When should I start looking for an apprenticeship?',
              answer:
                'Usually around a year before it begins, often in your third year of secondary school. Some companies recruit early, so it pays to start in good time.',
            },
            {
              question: 'How many apprenticeships should I consider?',
              answer:
                'A few that genuinely fit are better than a hundred guesses. When an apprenticeship suits you, your chances throughout the application process are stronger too.',
            },
            {
              question: 'What if I don’t know which career I want?',
              answer:
                'No problem. Begin with the career check. YourApplicant first learns what suits you, then shows you suitable apprenticeships.',
            },
          ],
        },
      },
    },
  },
  it: {
    localeName: 'Italiano',
    document: {
      titleSuffix: 'YourApplicant',
      pageTitles: {
        home: 'Studenti',
        schools: 'Scuole',
        companies: 'Aziende',
        pricing: 'Prezzi',
        about: 'Chi siamo',
        coach: 'Coach Anna',
        motivationLetter: 'Lettera di motivazione',
        cv: 'Curriculum',
        careerCheck: 'Check professionale',
        apprenticeships: 'Posti di tirocinio',
      },
    },
    common: {
      nav: {
        students: 'Studenti',
        schools: 'Scuole',
        companies: 'Aziende',
        pricing: 'Prezzi',
        about: 'Chi siamo',
      },
      actions: {
        login: 'Accedi',
        start: 'Inizia Ora',
        startLower: 'Inizia ora',
        discover: 'Scopri',
        create: 'Crea',
        beFound: 'Fatti trovare',
        apply: 'Candidati',
        register: 'Registrati',
        viewPricing: 'Vedi i prezzi',
        bookCall: 'Fissa un colloquio',
        bookFreeCall: 'Fissa un colloquio gratuito',
        contact: 'Contattaci',
        meetCoach: 'Conosci la tua coach',
        exploreJobs: 'Scopri i tirocini',
        createLetter: 'Crea la lettera di motivazione',
        createCv: 'Crea il curriculum',
        backHome: 'Torna alla home',
      },
      labels: {
        scroll: 'Scorri',
        online: 'Online',
      },
      aria: {
        home: 'Home di YourApplicant',
        mainNavigation: 'Navigazione principale',
        toggleNavigation: 'Mostra o nascondi la navigazione',
        openNavigation: 'Apri la navigazione',
        closeNavigation: 'Chiudi la navigazione',
        selectLanguage: 'Seleziona la lingua',
        languageMenu: 'Selezione della lingua',
        skipToContent: 'Vai al contenuto',
        scrollToContent: 'Scorri alla sezione successiva',
        previousSlide: 'Slide precedente',
        nextSlide: 'Slide successiva',
        pauseAnimation: 'Metti in pausa l’animazione',
        playAnimation: 'Avvia l’animazione',
        studentStories: 'Storie di successo di giovani apprendisti',
        productPreview: 'Anteprima dell’app YourApplicant',
        teacherDashboard: 'Dashboard YourApplicant per docenti',
        candidatePreview: 'Anteprima del profilo di un candidato',
        decreasePositions: 'Riduci il numero di posti di tirocinio',
        increasePositions: 'Aumenta il numero di posti di tirocinio',
        openFaq: 'Apri la risposta',
        closeFaq: 'Chiudi la risposta',
        externalLink: 'Si apre in una nuova scheda',
        loading: 'Caricamento del contenuto',
      },
      footer: {
        description:
          'YourApplicant aiuta studenti, scuole e aziende a trovare il tirocinio giusto, sul piano professionale e umano.',
        pagesTitle: 'Pagine',
        informationTitle: 'Informazioni',
        contactTitle: 'Contatti',
        pages: {
          students: 'Studenti',
          schools: 'Scuole',
          companies: 'Aziende',
          pricing: 'Prezzi',
          about: 'Chi siamo',
        },
        resources: {
          motivationLetter: 'Lettera di motivazione',
          cv: 'Curriculum',
          careerCheck: 'Check professionale',
          apprenticeships: 'Posti di tirocinio',
        },
        address: 'Bahnhofstrasse 1, 8001 Zurigo',
        copyright: '© 2026 YourApplicant. Tutti i diritti riservati.',
        createdBy: 'Creato da',
      },
    },
    home: {
      hero: {
        eyebrow: 'Gratuito per gli studenti',
        title: 'Il modo più semplice per trovare un tirocinio',
        subtitle: 'Il modo più semplice per trovare il tirocinio davvero adatto a te.',
        cta: 'Inizia Ora',
        proof: 'Consigliato da chi è già apprendista',
      },
      stories: {
        ariaLabel: 'Storie di successo di giovani apprendisti',
        cardLabel: 'Il mio match',
      },
      ribbon: 'Il tuo dossier. Tutte le opportunità.',
      dossier: {
        eyebrow: 'Dossier',
        title: 'Compilalo una volta.',
        titleAccent: 'Candidati sempre.',
        description:
          'Crea il tuo dossier una sola volta e invia ogni candidatura in meno di cinque minuti, con un profilo che convince davvero.',
        cta: 'Crea',
      },
      talentPool: {
        eyebrow: 'Talent pool',
        title: 'Non limitarti a candidarti.',
        titleAccent: 'Fatti trovare.',
        description:
          'Le aziende formatrici scoprono il tuo profilo e ti contattano direttamente perché sei proprio la persona che cercano.',
        cta: 'Fatti trovare',
        notification: 'UBS AG vorrebbe conoscerti',
      },
      matches: {
        eyebrow: 'Match di tirocinio',
        title: 'I tirocini giusti.',
        titleAccent: 'Direttamente per te.',
        description:
          'Non devi cercare da solo. YourApplicant trova automaticamente i tirocini più adatti a te.',
        companyLine: 'Posto di tirocinio presso YourApplicant a Zurigo come',
        role: 'Impiegato/a di commercio (turismo) AFC',
        year: '2026',
        strength: 'Match eccellente',
        reasonTitle: 'Perché SEI la persona giusta',
        reason:
          'Ti piace lavorare con le persone e ti interessano i viaggi e le altre culture. Il tuo impegno nella pallavolo e alla festa scolastica dimostra che sai fare squadra e assumerti responsabilità. La tua docente di classe ti descrive come una persona aperta e comunicativa. Con due stage d’orientamento in ambito commerciale e una media del 5.1, hai proprio il profilo che YourApplicant cerca.',
        apply: 'Candidati',
      },
      journey: {
        eyebrow: 'Ciao!',
        quote:
          'Dal primo “Che cosa voglio fare da grande?” fino al contratto di tirocinio firmato. Perché complicarsi la vita quando può essere semplice?',
        pills: [
          'Profilo della personalità',
          'Orientamento professionale',
          'Coach Anna',
          'Candidature',
          'Match',
          'Talent pool',
        ],
      },
      coach: {
        eyebrow: 'Coach Anna',
        title: 'Una coach personale.',
        titleAccent: 'Sempre con te.',
        description:
          'Dalla scelta professionale fino alla conferma. Coach Anna ti conosce, ti capisce e ha una risposta per ogni domanda.',
        cta: 'Inizia',
      },
      faq: {
        eyebrow: 'Domande frequenti',
        title: 'Le tue domande, con risposta.',
        items: [
          {
            question: 'Che cos’è YourApplicant?',
            answer:
              'YourApplicant è una piattaforma gratuita per gli studenti in Svizzera che cercano un posto di tirocinio. Crei il profilo una sola volta, trovi opportunità adatte e puoi essere contattato dalle aziende formatrici. Coach Anna ti accompagna dal primo passo fino alla conferma.',
          },
          {
            question: 'YourApplicant è davvero gratuito?',
            answer:
              'Sì. YourApplicant è completamente gratuito per gli studenti. Puoi creare il dossier, candidarti e utilizzare Coach Anna senza pagare nulla.',
          },
          {
            question: 'Quando dovrei iniziare a cercare un tirocinio?',
            answer:
              'Idealmente circa un anno prima dell’inizio. Conviene cominciare a candidarsi tra metà e fine delle vacanze estive, quando molte aziende pubblicano i posti. Qualunque sia il tuo punto di partenza, Coach Anna ti mostra il prossimo passo.',
          },
          {
            question: 'Come trovo un tirocinio adatto a me?',
            answer:
              'Crei un profilo con i tuoi punti di forza e interessi, poi YourApplicant ti propone i tirocini davvero adatti. Invece di sfogliare centinaia di annunci, vedi subito ciò che fa per te.',
          },
          {
            question: 'Che cosa offre YourApplicant rispetto ai normali portali?',
            answer:
              'I portali tradizionali mostrano tutti i posti. YourApplicant mostra quelli adatti a te, ti aiuta con la candidatura e permette alle aziende di trovarti. Non ti candidi soltanto: puoi anche essere scoperto.',
          },
          {
            question: 'Chi può vedere il mio profilo?',
            answer:
              'Soltanto le aziende formatrici potenzialmente adatte a te, e solo se lo desideri. Mantieni sempre il controllo su chi può vederti e su quando candidarti.',
          },
        ],
      },
      closing: {
        eyebrow: 'Il tuo futuro',
        title: 'Pronto per il prossimo passo?',
        description:
          'Il tuo futuro non inizia con una candidatura perfetta. Inizia con il primo passo.',
        cta: 'Inizia ora',
      },
    },
    schools: {
      hero: {
        eyebrow: 'Conforme al Piano di studio 21',
        title: 'Un percorso personale verso il mondo del lavoro',
        subtitle:
          'YourApplicant accompagna ogni allieva e ogni allievo nel proprio percorso verso il mondo del lavoro.',
        primaryCta: 'Inizia Ora',
        secondaryCta: 'Fissa un colloquio',
      },
      overview: {
        eyebrow: 'Perché le scuole moderne ci scelgono.',
        title: 'Meno lavoro per i docenti. Più risultati per gli studenti.',
        features: [
          {
            title: 'Panoramica della classe',
            description:
              'Vedi a colpo d’occhio i progressi di tutti: profilo, candidature e attività aperte per ogni allieva e ogni allievo.',
          },
          {
            title: 'Profili della personalità',
            description:
              'Conosci meglio la classe. I profili psicometrici aiutano a personalizzare le lezioni e sostenere ogni studente dal punto in cui si trova.',
          },
          {
            title: 'Tutti coinvolti',
            description:
              'Genitori, docenti e studenti collaborano in YourApplicant. Condividono valutazioni esterne, seguono i progressi e restano aggiornati.',
          },
        ],
      },
      journey: {
        eyebrow: 'Piano di studio 21',
        title: 'Come accompagniamo la tua classe',
        phases: [
          {
            phase: 'Fase 1',
            title: 'Autoriflessione',
            tags: ['Profilo della personalità'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Ciao Luca, giochi a calcio in una squadra. Sei mai stato capitano?',
              },
              {
                speaker: 'student',
                text: 'Sì, per una stagione. Ma non era niente di speciale.',
              },
              {
                speaker: 'anna',
                text: 'Invece sì. Da capitano motivi la squadra e decidi sotto pressione. Questo deve entrare nel tuo profilo.',
              },
            ],
          },
          {
            phase: 'Fasi 2 & 3',
            title: 'Motivazione',
            tags: ['Scelta professionale', 'Matching'],
            dialogue: [
              {
                speaker: 'student',
                text: 'Non so quale professione scegliere per il tirocinio.',
              },
              {
                speaker: 'anna',
                text: 'Crei siti web e ti piace giocare. Hai mai pensato a una professione tecnica, come l’informatico?',
              },
              {
                speaker: 'student',
                text: 'Non proprio, ma sembra interessante.',
              },
              {
                speaker: 'anna',
                text: 'Vuoi vedere com’è una giornata tipica da informatico e perché questa professione potrebbe fare per te?',
              },
            ],
          },
          {
            phase: 'Fase 4',
            title: 'Documenti',
            tags: ['Curriculum', 'Iter di candidatura', 'Candidature', 'Match', 'Talent pool'],
            dialogue: [
              {
                speaker: 'anna',
                text: 'Ciao Luca, è davvero ben fatto! Ricordati di citare la tua esperienza di guida come capitano di basket.',
              },
            ],
          },
        ],
      },
      steps: {
        eyebrow: 'Più semplice del previsto',
        title: 'Un accompagnamento moderno in 3 passi.',
        items: [
          {
            title: 'Registrazione',
            description: 'Registra la scuola e configura il profilo. 3 minuti.',
          },
          {
            title: 'Invito',
            description: 'Crea le classi. Gli studenti entrano con un codice QR. 15 minuti.',
          },
          {
            title: 'Accompagnamento',
            description: 'Gli studenti vengono seguiti automaticamente. Nessun lavoro in più.',
          },
        ],
      },
      faq: {
        eyebrow: 'Domande frequenti',
        title: 'Le tue domande, con risposta.',
        contactLead: 'Hai domande? Fissa un colloquio gratuito',
        contactCta: 'Fissa un colloquio gratuito',
        emailLead: 'oppure scrivici a',
        items: [
          {
            question: 'YourApplicant si integra nel Piano di studio 21?',
            answer:
              'Sì. YourApplicant è allineato al Piano di studio 21 e copre le attività importanti delle fasi da 1 a 4. Inoltre sostiene attivamente gli studenti nelle candidature, un ambito che i docenti non devono più gestire da soli.',
          },
          {
            question: 'Come gestisce la protezione dei dati YourApplicant?',
            answer:
              'I profili sono protetti e non accessibili al pubblico. Scuole e studenti mantengono il controllo sui dati, utilizzati solo per l’accompagnamento e la ricerca di un tirocinio e mai venduti.',
          },
          {
            question: 'Quanto lavoro richiede la configurazione?',
            answer:
              'La scuola si configura in pochi minuti. Poi crei le classi e gli studenti entrano con un codice QR. Non occorre installare nulla né seguire lunghe formazioni.',
          },
          {
            question: 'Su quali dispositivi funziona YourApplicant?',
            answer:
              'YourApplicant funziona nel browser su computer, tablet e smartphone. Studenti e docenti possono quindi usare i dispositivi già presenti a scuola.',
          },
        ],
      },
    },
    companies: {
      hero: {
        eyebrow: 'Per ora ancora gratuito',
        title: 'Trova la persona davvero giusta.',
        subtitle:
          'YourApplicant trova apprendisti adatti non solo al ruolo, ma anche alla vostra azienda e alla sua cultura sul piano umano.',
        primaryCta: 'Inizia Ora',
        secondaryCta: 'Fissa un colloquio',
        applications: 'Oltre 20 candidature',
        fit: 'Leandro soddisfa 4 requisiti su 4',
        requirements: [
          '3 stage d’orientamento commerciali',
          'Grande apertura ed estroversione',
          'Media scolastica del 5.1',
          'Scuola media, livello A',
        ],
      },
      features: {
        eyebrow: 'Per le aziende formatrici',
        title: 'Molto più di una borsa di lavoro.',
        items: [
          {
            title: 'Cerca nel talent pool.',
            description:
              'Trova talenti in base ai tuoi requisiti specifici. Contattali con un clic.',
          },
          {
            title: 'La tua posizione trova le persone giuste.',
            description:
              'Definisci una volta chi cerchi. Gli studenti adatti ricevono la posizione come proposta personale.',
          },
          {
            title: 'Più di un curriculum.',
            description:
              'Conosci la persona dietro la candidatura. Personalità, esperienze, punti di forza e valutazioni esterne a colpo d’occhio.',
          },
          {
            title: 'Una comunicazione che funziona.',
            description:
              'Tutto passa da YourApplicant. Niente caos nelle e-mail, tutto in un unico posto. Gli studenti ricevono promemoria automatici.',
          },
        ],
      },
      recruiting: {
        eyebrow: 'Candidature',
        title: 'Recruiting senza caos.',
        cta: 'Inizia',
        items: [
          {
            title: 'Documenti completi.',
            description:
              'Gli studenti si candidano con profili completi e personali. Basta documenti mancanti.',
          },
          {
            title: 'Processo su misura',
            description:
              'Definite stati personalizzati e gestite le candidature secondo i vostri processi interni.',
          },
          {
            title: 'Screening in 10 secondi',
            description:
              'Tutte le informazioni importanti a colpo d’occhio, prima ancora di aprire un documento.',
          },
        ],
        statusTitle: 'Nome dello stato',
        statusLabels: [
          { label: 'Reparto', count: 7 },
          { label: 'Giornate di prova', count: 3 },
          { label: 'Colloquio', count: 3 },
          { label: 'Rinuncia', count: 8 },
          { label: 'Conferma', count: 5 },
          { label: 'Rifiuto', count: 3 },
          { label: '2° colloquio', count: 3 },
          { label: 'Screening', count: 12 },
        ],
      },
      audiences: {
        eyebrow: 'Per ogni azienda',
        title: 'Per chiunque formi apprendisti.',
        cta: 'Inizia ora',
        items: [
          {
            title: 'PMI',
            description:
              'Poco tempo e risorse HR limitate. Arrivare rapidamente alla persona più adatta, senza un processo pesante.',
          },
          {
            title: 'Grandi aziende',
            description:
              'Molte candidature e processi complessi. Una gestione strutturata che si integra nei flussi esistenti.',
          },
          {
            title: 'Aziende a corto di nuove leve',
            description:
              'Per professioni che faticano ad attirare i giovani. YourApplicant propone attivamente la vostra posizione agli studenti adatti.',
          },
          {
            title: 'Aziende che si assicurano presto i migliori',
            description:
              'Riconoscete i talenti prima che vengano scelti. Contattate in modo attivo le persone giuste nel talent pool.',
          },
        ],
      },
      steps: {
        eyebrow: 'Più semplice del previsto',
        title: 'L’apprendista giusto in 3 passi.',
        items: [
          {
            title: 'Registrazione',
            description: 'Registra l’azienda e configura il profilo. 3 minuti.',
          },
          {
            title: 'Pubblicazione',
            description: 'Crea la posizione e definisci i requisiti. 10 minuti.',
          },
          {
            title: 'Ricezione delle candidature',
            description:
              'Gli studenti adatti si candidano direttamente, oppure li cercate nel talent pool.',
          },
        ],
      },
      faq: {
        eyebrow: 'Domande frequenti',
        title: 'Le vostre domande, con risposta.',
        items: [
          {
            question: 'Che cos’è YourApplicant per le aziende?',
            answer:
              'YourApplicant aiuta le aziende formatrici a trovare apprendisti adatti sul piano professionale e umano. Ricevete candidature complete, potete cercare nel talent pool e farvi trovare dagli studenti giusti. Tutto in un unico posto, senza caos nelle e-mail.',
          },
          {
            question: 'Quanto costa YourApplicant per le aziende?',
            answer:
              'Iniziare è gratuito. Potete pubblicare un posto di tirocinio e ricevere candidature complete senza costi. Per cercare attivamente nel talent pool o contattare direttamente i profili preferiti, scegliete un piano a pagamento.',
          },
          {
            question: 'Quanto lavoro richiede la configurazione?',
            answer:
              'Molto poco. Registrate l’azienda e configurate il profilo in circa tre minuti. Poi create la posizione in una decina di minuti e iniziate a ricevere candidature adatte. Nessuna lunga configurazione o formazione.',
          },
          {
            question: 'Come aiuta YourApplicant quando mancano candidature?',
            answer:
              'Invece di aspettare, trovate gli studenti adatti nel talent pool e li contattate direttamente. La vostra posizione viene anche proposta in automatico ai giovani giusti, persino se non conoscono ancora l’azienda.',
          },
          {
            question: 'Le candidature sono complete?',
            answer:
              'Sì. Gli studenti si candidano con un dossier completo che mostra personalità, punti di forza ed esperienze. Vedete in pochi secondi se una persona è adatta, prima di aprire un documento. Basta materiali mancanti.',
          },
          {
            question: 'Per quali aziende è pensato YourApplicant?',
            answer:
              'Per ogni azienda che forma apprendisti: dalla PMI con poco tempo e un team HR ridotto alla grande impresa con molte candidature. È particolarmente utile per chi fatica a trovare nuove leve o vuole assicurarsi presto i talenti migliori.',
          },
        ],
      },
    },
    pricing: {
      hero: {
        eyebrow: 'Panoramica dei prezzi',
        tabs: {
          companies: 'Aziende',
          schools: 'Scuole',
        },
        title: 'Incredibilmente Semplice. Incredibilmente Efficace.',
      },
      counterLabel: 'Numero di posti di tirocinio',
      currency: 'CHF',
      period: '/ anno',
      includedLabel: 'Che cosa include',
      plans: [
        {
          name: 'Starter',
          price: '0',
          description: 'Per le PMI. Inizia facilmente e ricevi subito candidature.',
          features: [
            { label: 'Annunci di tirocinio interessanti', available: true },
            { label: 'Aiuto nella creazione dell’annuncio', available: true },
            { label: 'Posizione proposta ai profili preferiti', available: false },
            { label: 'Screening delle candidature in 10 secondi', available: true },
            { label: 'Candidature sempre complete', available: true },
            { label: 'Dossier personale di ogni candidato', available: true },
            { label: 'Tutta la comunicazione in un unico posto', available: true },
            { label: 'Definizione del proprio iter di candidatura', available: false },
            { label: 'Invito del team', available: false },
            { label: 'Ricerca nel talent pool', available: false },
            { label: 'Contatto diretto dei candidati', available: false },
          ],
          cta: 'Inizia ora',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Essential',
          price: '240',
          description: 'Per aziende che reclutano in team e vogliono processi propri.',
          features: [
            { label: 'Annunci di tirocinio interessanti', available: true },
            { label: 'Aiuto nella creazione dell’annuncio', available: true },
            { label: 'Posizione proposta ai profili preferiti', available: true },
            { label: 'Screening delle candidature in 10 secondi', available: true },
            { label: 'Candidature sempre complete', available: true },
            { label: 'Dossier personale di ogni candidato', available: true },
            { label: 'Tutta la comunicazione in un unico posto', available: true },
            { label: 'Definizione del proprio iter di candidatura', available: true },
            { label: 'Invito del team', available: true },
            { label: 'Ricerca nel talent pool', available: false },
            { label: 'Contatto diretto dei candidati', available: false },
          ],
          cta: 'Inizia ora',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Pro',
          price: '690',
          description:
            'Per aziende che cercano in modo attivo. Assicuratevi i migliori prima che vengano scelti.',
          features: [
            { label: 'Tutto ciò che include Essential', available: true },
            { label: 'Ricerca illimitata nel talent pool', available: true },
            {
              label: 'Contatto diretto dei profili preferiti prima che vengano scelti.',
              available: true,
            },
          ],
          cta: 'Inizia ora',
          ctaState: { disabled: false, gated: false, minimumPositions: 0 },
          note: '',
        },
        {
          name: 'Enterprise',
          price: 'Su richiesta',
          description: 'Per grandi aziende con almeno 10 posti di tirocinio.',
          features: [
            { label: 'Tutto ciò che include Pro', available: true },
            { label: 'Referente personale', available: true },
            { label: 'Onboarding su misura', available: true },
            { label: 'Integrazione nei sistemi esistenti', available: true },
          ],
          cta: 'Contattaci',
          ctaState: { disabled: true, gated: true, minimumPositions: 10 },
          note: 'Disponibile da 10 posti di tirocinio.',
        },
      ],
      schoolsPanel: {
        eyebrow: 'Panoramica dei prezzi',
        title: 'Pensato per le scuole.',
        titleAccent: 'Accompagnare con semplicità.',
        studentCountLabel: 'Numero di studenti',
        trialBadge: '3 mesi di prova gratuiti',
        price: '20',
        currency: 'CHF',
        period: '/ anno',
        perStudentLabel: 'per studente all’anno',
        description:
          'Per le scuole. Iniziate facilmente e accompagnate ogni studente in modo personale.',
        cta: 'Fissa un colloquio',
        note:
          'Chiariamo insieme tutte le domande aperte e parliamo dei prossimi passi.',
        features: [
          { label: 'Annunci di tirocinio interessanti', available: true },
          { label: 'Aiuto nella creazione dell’annuncio', available: true },
          { label: 'Screening delle candidature in 10 secondi', available: true },
          { label: 'Candidature sempre complete', available: true },
          { label: 'Dossier personale di ogni candidato', available: true },
          { label: 'Tutta la comunicazione in un unico posto', available: true },
          { label: 'Definizione del proprio iter di candidatura', available: true },
          { label: 'Invito del team', available: true },
          { label: 'Ricerca nel talent pool', available: false },
          { label: 'Contatto diretto dei candidati', available: false },
        ],
      },
    },
    about: {
      hero: {
        title: 'Il tirocinio giusto può cambiare una vita.',
        subtitle:
          'Siamo convinti che un vero match, professionale e umano, renda i giovani più motivati, li aiuti a sviluppare meglio il proprio potenziale e permetta loro di imparare di più. Un inizio migliore nella vita e i nuovi talenti di cui l’economia svizzera ha bisogno.',
      },
      story: {
        title: 'Com’è nato YourApplicant',
        description:
          'Devin Baucamp racconta la propria storia, la nascita di YourApplicant e la motivazione che anima questo movimento',
        videoAria: 'Riproduci la storia di YourApplicant',
      },
      team: {
        eyebrow: 'Le persone dietro il progetto',
        title: 'Il nostro team',
        members: [
          { name: 'Devin Baucamp', role: 'CEO & Fondatore' },
          { name: 'Lubo Dilov', role: 'Lead Developer' },
          { name: 'Aleksander Dimitrov', role: 'Frontend Developer' },
          { name: 'Aleyna Arslan', role: 'Content & Marketing' },
          { name: 'Samira Bannwart', role: 'Consulenza & Sales' },
          { name: 'Leon Sarkis', role: 'Sales & Partnership' },
        ],
      },
    },
    resources: {
      coach: {
        slug: '/coach',
        hero: {
          eyebrow: 'Gratuito per gli studenti',
          title: 'La tua coach personale.',
          titleAccent: 'Sempre con te.',
          subtitle:
            'Dalla scelta professionale fino alla conferma. Coach Anna ti conosce, ti capisce e segue ogni passo.',
          cta: 'Inizia ora',
        },
        intro:
          'Non devi trovare da solo la strada verso il tirocinio. Coach Anna impara a conoscerti tramite il profilo, risponde alle tue domande e ti indica il prossimo passo utile.',
        section: {
          title: 'Coach Anna ti accompagna',
          items: [
            {
              title: 'Impara a conoscerti.',
              description:
                'Attraverso il profilo, Coach Anna comprende interessi, punti di forza ed esperienze.',
            },
            {
              title: 'Ragiona insieme a te.',
              description:
                'Chiedile tutto sulla scelta professionale, il dossier o le candidature. Ricevi una risposta adatta a te.',
            },
            {
              title: 'Resta al tuo fianco.',
              description:
                'Dalla prima idea fino alla conferma, ti ricorda che cosa conta nel passo successivo.',
            },
          ],
        },
        cta: {
          title: 'Conosci Coach Anna',
          subtitle: 'Gratuita, personale e sempre disponibile per te.',
          label: 'Inizia ora',
        },
        faq: {
          title: 'Domande frequenti su Coach Anna.',
          items: [
            {
              question: 'Che cos’è Coach Anna?',
              answer:
                'Coach Anna è la tua guida personale in YourApplicant. Conosce il tuo profilo, risponde alle domande e ti sostiene dalla scelta professionale fino alla conferma, quando ne hai bisogno e in modo personalizzato.',
            },
            {
              question: 'Che cosa posso chiedere a Coach Anna?',
              answer:
                'Puoi chiedere tutto ciò che riguarda la scelta professionale e la ricerca di un tirocinio: professioni adatte, punti di forza, curriculum, lettera di motivazione, candidature o un colloquio imminente.',
            },
            {
              question: 'Coach Anna è gratuita?',
              answer:
                'Sì. Coach Anna e tutte le funzioni di YourApplicant sono gratuite per gli studenti.',
            },
            {
              question: 'Coach Anna sostituisce l’orientamento professionale?',
              answer:
                'Coach Anna completa il sostegno di genitori, scuola e orientatori. È sempre disponibile e ti aiuta a preparare e realizzare i prossimi passi.',
            },
          ],
        },
      },
      motivationLetter: {
        slug: '/motivationsschreiben-lehrstelle',
        hero: {
          eyebrow: 'Gratuito per gli studenti',
          title: 'La tua lettera di motivazione.',
          titleAccent: 'Che convince.',
          subtitle:
            'Scrivi in pochi minuti una lettera per il tirocinio che rispecchia davvero chi sei.',
          cta: 'Inizia Ora',
        },
        intro:
          'Una buona lettera di motivazione spesso decide se verrai invitato a un colloquio. Scopri a che cosa prestano attenzione le aziende formatrici e come creare una lettera di candidatura convincente.',
        section: {
          title: 'Come scrivere una buona lettera',
          items: [
            {
              title: 'Spiega perché proprio questa azienda.',
              description:
                'Non restare sul generico: racconta che cosa ti attira esattamente di questo tirocinio.',
            },
            {
              title: 'Porta un esempio concreto.',
              description:
                'Uno stage d’orientamento, un hobby o un progetto che collega te e la professione.',
            },
            {
              title: 'Meno è meglio.',
              description:
                'Mezza pagina basta. Uno o due punti autentici valgono più di tante frasi vuote.',
            },
          ],
        },
        cta: {
          title: 'Crea la lettera di motivazione',
          subtitle: 'Con Coach Anna. Gratis, in pochi minuti.',
          label: 'Crea la lettera di motivazione',
        },
        faq: {
          title: 'Domande frequenti sulla lettera di motivazione.',
          items: [
            {
              question: 'Quanto deve essere lunga una lettera di motivazione?',
              answer:
                'Da mezza pagina a non più di una pagina A4. Le aziende leggono molte candidature, quindi ogni frase conta. Tre o quattro paragrafi brevi sono più che sufficienti.',
            },
            {
              question: 'Come inizio una lettera di motivazione?',
              answer:
                'Indica già nella prima frase per quale tirocinio ti candidi e perché ti interessa. Evita lunghe introduzioni e vai subito al punto.',
            },
            {
              question: 'Che cosa va inserito nella lettera di motivazione?',
              answer:
                'Tre cose: perché proprio questa azienda, che cosa porti già con te – stage, hobby o punti di forza – e perché la professione fa per te. Concludi dicendo che attendi con piacere un colloquio.',
            },
            {
              question: 'Che differenza c’è tra lettera di motivazione e lettera di candidatura?',
              answer:
                'Di solito indicano la stessa cosa. Entrambe spiegano perché ti candidi per il tirocinio e perché sei la persona giusta. Le aziende usano semplicemente nomi diversi.',
            },
          ],
        },
      },
      cv: {
        slug: '/lebenslauf-lehrstelle',
        hero: {
          eyebrow: 'Gratuito per gli studenti',
          title: 'Il tuo curriculum.',
          titleAccent: 'Pronto in pochi minuti.',
          subtitle:
            'Crea un curriculum ordinato per il tirocinio, con tutto ciò che conta davvero.',
          cta: 'Inizia Ora',
        },
        intro:
          'Il curriculum è la prima cosa che un’azienda formatrice vede di te. Scopri che cosa deve contenere e creane in pochi minuti uno ordinato e completo per il tirocinio.',
        section: {
          title: 'Come creare un buon curriculum',
          items: [
            {
              title: 'Prima le informazioni più recenti.',
              description:
                'Inizia dalla scuola che frequenti oggi e procedi a ritroso. Le informazioni attuali vanno in alto.',
            },
            {
              title: 'Mostra che cosa ti distingue.',
              description:
                'Scegli tre o quattro veri punti di forza invece di un lungo elenco. Pochi, ma davvero adatti a te.',
            },
            {
              title: 'Mantienilo chiaro.',
              description:
                'Una pagina, sezioni chiare e una buona foto. Le aziende formatrici decidono in pochi secondi.',
            },
          ],
        },
        cta: {
          title: 'Crea il curriculum',
          subtitle: 'Con Coach Anna. Gratis, in pochi minuti.',
          label: 'Crea il curriculum',
        },
        faq: {
          title: 'Domande frequenti sul curriculum.',
          items: [
            {
              question: 'Che cosa va nel curriculum per un tirocinio?',
              answer:
                'Dati personali, formazione scolastica, eventuali stage d’orientamento, hobby, lingue e punti di forza. In alto va aggiunta una foto recente e cordiale.',
            },
            {
              question: 'Quanto deve essere lungo il curriculum?',
              answer:
                'Una pagina A4 è sufficiente. Da studente non hai ancora molti anni di esperienza professionale, quindi il curriculum resta breve e facile da leggere.',
            },
            {
              question: 'Il curriculum deve avere una foto?',
              answer:
                'In Svizzera sì. Una buona foto neutra fa parte di una candidatura completa. Sceglila cordiale e curata: niente selfie o foto delle vacanze.',
            },
            {
              question: 'Che differenza c’è tra curriculum e CV?',
              answer:
                'Nessuna. CV è l’abbreviazione di Curriculum Vitae e indica esattamente lo stesso documento.',
            },
          ],
        },
      },
      careerCheck: {
        slug: '/berufscheck',
        hero: {
          eyebrow: 'Gratuito per gli studenti',
          title: 'Quale professione',
          titleAccent: 'fa per te?',
          subtitle:
            'Non devi scoprirlo da solo. Coach Anna ti accompagna finché trovi la professione adatta a te.',
          cta: 'Inizia ora',
        },
        intro:
          'Non sai che cosa vuoi fare? È del tutto normale e non devi scoprirlo da solo. Coach Anna ti conosce attraverso il profilo, esplora insieme a te ciò che ti riesce bene e ti accompagna passo dopo passo verso il tirocinio giusto.',
        section: {
          title: 'Coach Anna ti accompagna',
          items: [
            {
              title: 'Rispondi ad alcune domande.',
              description:
                'Con poche domande e il tuo profilo, Coach Anna capisce che cosa ti caratterizza e ti riesce bene.',
            },
            {
              title: 'Ragiona insieme a te.',
              description:
                'Puoi chiederle qualsiasi cosa. Coach Anna ti aiuta a fare chiarezza, con i tuoi tempi.',
            },
            {
              title: 'Ti porta al tirocinio giusto.',
              description:
                'Grazie a ciò che sa di te, ti mostra professioni e tirocini davvero adatti.',
            },
          ],
        },
        cta: {
          title: 'Inizia ora',
          subtitle: 'Con Coach Anna. Gratis, in pochi minuti.',
          label: 'Inizia ora',
        },
        faq: {
          title: 'Domande frequenti sulla scelta professionale.',
          items: [
            {
              question: 'Come scopro quale professione fa per me?',
              answer:
                'Non devi scoprirlo da solo. Coach Anna ti accompagna passo dopo passo, impara a conoscere tutto il tuo profilo e ti aiuta a trovare la professione davvero adatta. Il test è solo l’inizio.',
            },
            {
              question: 'Che cos’è Coach Anna?',
              answer:
                'Coach Anna è la tua guida personale in YourApplicant. Conosce il tuo profilo, risponde alle domande e ti sostiene dalla scelta professionale fino alla conferma, quando ne hai bisogno e in modo personalizzato.',
            },
            {
              question: 'E se non ho ancora idea di che cosa voglio?',
              answer:
                'YourApplicant serve proprio a questo. All’inizio non devi avere già le risposte. Coach Anna esplora con te ciò che sai fare e ti interessa, aiutandoti a fare chiarezza passo dopo passo.',
            },
          ],
        },
      },
      apprenticeships: {
        slug: '/lehrstellen',
        hero: {
          eyebrow: 'Gratuito per gli studenti',
          title: 'Trova tirocini',
          titleAccent: 'davvero adatti a te.',
          subtitle:
            'Non sfogliare centinaia di annunci. YourApplicant ti mostra i posti di tirocinio che fanno davvero per te.',
          cta: 'Scopri i tirocini',
        },
        intro:
          'Ci sono migliaia di posti di tirocinio aperti. Ma qual è quello giusto? Invece di aprire ogni annuncio, YourApplicant ti propone opportunità vicine a te e adatte alla tua personalità e ai tuoi punti di forza.',
        section: {
          title: 'Come trovare il tuo tirocinio',
          items: [
            {
              title: 'Raccontaci che cosa ti distingue.',
              description:
                'Attraverso il profilo, YourApplicant conosce punti di forza, interessi e regione preferita.',
            },
            {
              title: 'Scopri i tirocini adatti.',
              description:
                'Ricevi proposte che fanno davvero per te, invece di un elenco infinito.',
            },
            {
              title: 'Fatti trovare.',
              description:
                'Le aziende formatrici scoprono il tuo profilo e ti contattano direttamente.',
            },
          ],
        },
        cta: {
          title: 'Scopri i tirocini',
          subtitle: 'Con Coach Anna. Gratis, in pochi minuti.',
          label: 'Scopri i tirocini',
        },
        faq: {
          title: 'Domande frequenti sulla ricerca di un tirocinio',
          items: [
            {
              question: 'Dove trovo posti di tirocinio aperti in Svizzera?',
              answer:
                'Puoi trovare le offerte su diversi portali. YourApplicant va oltre e ti propone in modo mirato i tirocini adatti alla tua personalità, ai tuoi punti di forza e alla tua zona.',
            },
            {
              question: 'Quando dovrei iniziare a cercare un tirocinio?',
              answer:
                'Di solito circa un anno prima dell’inizio, spesso durante il terzo anno di scuola media. Alcune aziende scelgono presto, quindi conviene muoversi per tempo.',
            },
            {
              question: 'Quanti tirocini dovrei valutare?',
              answer:
                'Meglio pochi davvero adatti che cento scelti a caso. Se il tirocinio fa per te, aumentano anche le possibilità lungo tutto l’iter di candidatura.',
            },
            {
              question: 'E se non so ancora quale professione scegliere?',
              answer:
                'Nessun problema. Inizia con il check professionale. YourApplicant scopre prima che cosa fa per te e poi ti mostra i tirocini adatti.',
            },
          ],
        },
      },
    },
  },
};

export default translations;
